app.config([
  '$translateProvider',
  function ($translateProvider) {
    $translateProvider.translations("ko", {
        "AC": "어센션섬",
        "AD": "안도라",
        "AE": "아랍에미리트",
        "AF": "아프가니스탄",
        "AG": "안티구아 바부다",
        "AI": "앵귈라",
        "AL": "알바니아",
        "AM": "아르메니아",
        "AN": "네덜란드령 안틸레스",
        "AO": "앙골라",
        "AQ": "남극 대륙",
        "AR": "아르헨티나",
        "AS": "아메리칸 사모아",
        "AT": "오스트리아",
        "AU": "호주",
        "AW": "아루바",
        "AX": "올란드 제도",
        "AZ": "아제르바이잔",
        "BA": "보스니아 헤르체고비나",
        "BB": "바베이도스",
        "BD": "방글라데시",
        "BE": "벨기에",
        "BF": "부르키나파소",
        "BG": "불가리아",
        "BH": "바레인",
        "BI": "부룬디",
        "BJ": "베냉",
        "BL": "생바르텔레미",
        "BM": "버뮤다",
        "BN": "브루나이",
        "BO": "볼리비아",
        "BQ": "카리브 네덜란드",
        "BR": "브라질",
        "BS": "바하마",
        "BT": "부탄",
        "BV": "부베섬",
        "BW": "보츠와나",
        "BY": "벨라루스",
        "BZ": "벨리즈",
        "CA": "캐나다",
        "CC": "코코스 제도",
        "CD": "콩고 민주 공화국",
        "CF": "중앙아프리카 공화국",
        "CG": "콩고 공화국",
        "CH": "스위스",
        "CI": "코트디부아르",
        "CK": "쿡 제도",
        "CL": "칠레",
        "CM": "카메룬",
        "CN": "중국",
        "CO": "콜롬비아",
        "CP": "클리퍼턴섬",
        "CR": "코스타리카",
        "CU": "쿠바",
        "CV": "카보베르데",
        "CW": "퀴라소",
        "CX": "크리스마스섬",
        "CY": "키프로스",
        "CZ": "체코",
        "DE": "독일",
        "DG": "디에고가르시아섬",
        "DJ": "지부티",
        "DK": "덴마크",
        "DM": "도미니카",
        "DO": "도미니카 공화국",
        "DZ": "알제리",
        "EA": "세우타 및 멜리야",
        "EC": "에콰도르",
        "EE": "에스토니아",
        "EG": "이집트",
        "EH": "서사하라",
        "ER": "에리트레아",
        "ES": "스페인",
        "ET": "에티오피아",
        "EU": "유럽 연합",
        "FI": "핀란드",
        "FJ": "피지",
        "FK": "포클랜드 제도 (말비나스 제도)",
        "FM": "미크로네시아 연방",
        "FO": "페로 제도",
        "FR": "프랑스",
        "GA": "가봉",
        "GB": "영국",
        "GD": "그레나다",
        "GE": "조지아",
        "GF": "프랑스령 기아나",
        "GG": "건지섬",
        "GH": "가나",
        "GI": "지브롤터",
        "GL": "그린란드",
        "GM": "감비아",
        "GN": "기니",
        "GP": "과들루프",
        "GQ": "적도 기니",
        "GR": "그리스",
        "GS": "사우스조지아 사우스샌드위치 제도",
        "GT": "과테말라",
        "GU": "괌",
        "GW": "기니비사우",
        "GY": "가이아나",
        "HK": "홍콩",
        "HM": "허드 맥도널드 제도",
        "HN": "온두라스",
        "HR": "크로아티아",
        "HT": "아이티",
        "HU": "헝가리",
        "IC": "카나리아 제도",
        "ID": "인도네시아",
        "IE": "아일랜드",
        "IL": "이스라엘",
        "IM": "맨섬",
        "IN": "인도",
        "IO": "영국령 인도양 지역",
        "IQ": "이라크",
        "IR": "이란",
        "IS": "아이슬란드",
        "IT": "이탈리아",
        "JE": "저지섬",
        "JM": "자메이카",
        "JO": "요르단",
        "JP": "일본",
        "KE": "케냐",
        "KG": "키르기스스탄",
        "KH": "캄보디아",
        "KI": "키리바시",
        "KM": "코모로",
        "KN": "세인트키츠 네비스",
        "KP": "북한",
        "KR": "대한민국",
        "KW": "쿠웨이트",
        "KY": "케이맨 제도",
        "KZ": "카자흐스탄",
        "LA": "라오스",
        "LB": "레바논",
        "LC": "세인트루시아",
        "LI": "리히텐슈타인",
        "LK": "스리랑카",
        "LR": "라이베리아",
        "LS": "레소토",
        "LT": "리투아니아",
        "LU": "룩셈부르크",
        "LV": "라트비아",
        "LY": "리비아",
        "MA": "모로코",
        "MC": "모나코",
        "MD": "몰도바",
        "ME": "몬테네그로",
        "MF": "프랑스령 세인트마틴섬",
        "MG": "마다가스카르",
        "MH": "마셜 제도",
        "MK": "북마케도니아",
        "ML": "말리",
        "MM": "미얀마",
        "MN": "몽골",
        "MO": "마카오",
        "MP": "북마리아나 제도",
        "MQ": "마르티니크",
        "MR": "모리타니",
        "MS": "몬트세랫",
        "MT": "몰타",
        "MU": "모리셔스",
        "MV": "몰디브",
        "MW": "말라위",
        "MX": "멕시코",
        "MY": "말레이시아",
        "MZ": "모잠비크",
        "NA": "나미비아",
        "NC": "뉴칼레도니아",
        "NE": "니제르",
        "NF": "노퍽섬",
        "NG": "나이지리아",
        "NI": "니카라과",
        "NL": "네덜란드",
        "NO": "노르웨이",
        "NP": "네팔",
        "NR": "나우루",
        "NU": "니우에",
        "NZ": "뉴질랜드",
        "OM": "오만",
        "PA": "파나마",
        "PE": "페루",
        "PF": "프랑스령 폴리네시아",
        "PG": "파푸아뉴기니",
        "PH": "필리핀",
        "PK": "파키스탄",
        "PL": "폴란드",
        "PM": "생피에르 미클롱",
        "PN": "피트케언 제도",
        "PR": "푸에르토리코",
        "PS": "팔레스타인 영토",
        "PT": "포르투갈",
        "PW": "팔라우",
        "PY": "파라과이",
        "QA": "카타르",
        "QO": "오세아니아 외곽 제도",
        "RE": "레위니옹",
        "RO": "루마니아",
        "RS": "세르비아",
        "RU": "러시아",
        "RW": "르완다",
        "SA": "사우디아라비아",
        "SB": "솔로몬 제도",
        "SC": "세이셸",
        "SD": "수단",
        "SE": "스웨덴",
        "SG": "싱가포르",
        "SH": "세인트헬레나",
        "SI": "슬로베니아",
        "SJ": "스발바르 얀마옌",
        "SK": "슬로바키아",
        "SL": "시에라리온",
        "SM": "산마리노",
        "SN": "세네갈",
        "SO": "소말리아",
        "SR": "수리남",
        "SS": "남수단",
        "ST": "상투메 프린시페",
        "SV": "엘살바도르",
        "SX": "네덜란드령 세인트마틴섬",
        "SY": "시리아",
        "SZ": "에스와티니",
        "TA": "트리스탄다쿠냐",
        "TC": "터크스 케이커스 제도",
        "TD": "차드",
        "TF": "프랑스령 남방 및 남극 지역",
        "TG": "토고",
        "TH": "태국",
        "TJ": "타지키스탄",
        "TK": "토켈라우",
        "TL": "동티모르",
        "TM": "투르크메니스탄",
        "TN": "튀니지",
        "TO": "통가",
        "TR": "튀르키예",
        "TT": "트리니다드 토바고",
        "TV": "투발루",
        "TW": "대만",
        "TZ": "탄자니아",
        "UA": "우크라이나",
        "UG": "우간다",
        "UM": "미국령 소군도",
        "US": "미국",
        "UY": "우루과이",
        "UZ": "우즈베키스탄",
        "VA": "바티칸 시국",
        "VC": "세인트빈센트 그레나딘",
        "VE": "베네수엘라",
        "VG": "영국령 버진아일랜드",
        "VI": "미국령 버진아일랜드",
        "VN": "베트남",
        "VU": "바누아투",
        "WF": "왈리스 푸투나",
        "WS": "사모아",
        "YE": "예멘",
        "YT": "마요트",
        "ZA": "남아프리카 공화국",
        "ZM": "잠비아",
        "ZW": "짐바브웨",
        "ZZ": "알 수 없는 지역",
        "action.add_photo": "사진 추가",
        "action.load_earlier": "이전 내용 보기",
        "action.load_more": "더 보기",
        "action.send": "발송하기",
        "address.fields.address": "주소",
        "address.fields.address.city": "도시",
        "address.fields.address.country": "국가/지역",
        "address.fields.address.postcode": "우편번호 (해당되는 경우)",
        "address.fields.address.recipient_name": "수령인",
        "address.fields.address.remarks": "메모",
        "address.fields.address.state": "시/도/지역",
        "address.fields.city": "도시",
        "address.fields.country": "국가/지역",
        "address.fields.postcode": "우편번호",
        "address.fields.recipient_name": "수령인",
        "attachment.upload.description": "파일 용량 2MB 이하\n형식: pdf, doc, docx, xls, xlsx, csv, jpg, jpeg, png, gif",
        "back": "돌아가기",
        "back_in_stock.added": "재입고 알림 설정됨",
        "back_in_stock.avaiable": "재입고 알림 받기",
        "back_in_stock.subscibe.success.message": "상품 재입고 시 알림을 보내드립니다",
        "back_member_center": "마이페이지로 돌아가기",
        "birthday_picker.date.placeholder": "일",
        "birthday_picker.month.placeholder": " 월",
        "birthday_picker.year.placeholder": " 년",
        "cart": "장바구니",
        "cart.affiliate_code.apply_success": "추천인 코드 적용됨",
        "cart.checkout": "결제하기",
        "cart.clean": "지금 바로 결제하기!",
        "cart.copy.info.affiliate_code": "추천인 코드 ({{code}}), ",
        "cart.copy.info.copied": "복사된 URL: ",
        "cart.copy.info.product_count": "상품 {{count}}개",
        "cart.coupon_code.apply_success": "쿠폰이 적용됨",
        "cart.empty": "장바구니가 비어 있습니다",
        "cart.empty.continue": "쇼핑 계속하기!",
        "cart.empty.description": "장바구니에 상품을 담아보세요",
        "cart.item.remove": "삭제",
        "cart.items.remove": "삭제",
        "cart.lock_cart_sc_product.description": "라이브/포스트 판매 상품으로 구매 수량을 변경할 수 없습니다",
        "cart.lock_cart_sc_product.remove_hint": "라이브/포스트 판매 상품으로 삭제할 수 없습니다",
        "cart.over_limit": "장바구니 상품 수가 <span class=\"limit-number\">{{limit_number}}</span>개 제한을 초과했습니다. 먼저 일부를 결제 후 다시 담아주세요! 로그인하시면 찜 목록에 담아둘 수 있습니다",
        "cart.over_limit.login": "장바구니 상품 수가 <span class=\"limit-number\">{{limit_number}}</span>개 제한을 초과했습니다. 먼저 일부를 결제 후 다시 담아주세요! 찜 목록에 담아둘 수 있습니다.",
        "cart.promotion.bundle_group.has_items_selected": "A 그룹 <b style=\"color: #f05c53\">{{red_quantity}}</b>개 선택{{red_reminder}}, B 그룹 <b style=\"color: #1ba462\">{{green_quantity}}</b>개 선택{{green_reminder}}{{applied_reminder}}",
        "cart.promotion.bundle_group.has_items_selected.mobile": "A 그룹 <b style=\"color: #f05c53\">{{red_quantity}}</b>개, B 그룹 <b style=\"color: #1ba462\">{{green_quantity}}</b>개",
        "cart.promotion.checkout": "장바구니로 이동",
        "cart.promotion.has_items_selected": "<b>{{quantity}}</b>개 선택됨",
        "cart.promotion_reminder.amount": "{{gap}} 추가 구매 시 ",
        "cart.promotion_reminder.applied.discount": "할인 혜택이 적용됐습니다. ",
        "cart.promotion_reminder.applied.discount_prefix": ",",
        "cart.promotion_reminder.applied.free_shipping": "무료 배송 혜택이 적용됐습니다. ",
        "cart.promotion_reminder.applied.gift": "사은품이 적용됐습니다. ",
        "cart.promotion_reminder.applied.reward_campaign": "혜택이 적용됐습니다. ",
        "cart.promotion_reminder.applied_highest.discount": "할인 혜택이 적용됐습니다!",
        "cart.promotion_reminder.applied_highest.free_shipping": "무료 배송 혜택이 적용됐습니다!",
        "cart.promotion_reminder.applied_highest.gift": "사은품이 적용됐습니다!",
        "cart.promotion_reminder.applied_highest.reward_campaign": "혜택이 적용됐습니다!",
        "cart.promotion_reminder.discount_target.discount": "할인 혜택이 적용됩니다!",
        "cart.promotion_reminder.discount_target.free_shipping": "무료 배송 혜택이 적용됩니다!",
        "cart.promotion_reminder.discount_target.gift": "사은품이 적용됩니다!",
        "cart.promotion_reminder.discount_target.reward_campaign": "혜택이 적용됐습니다!",
        "cart.promotion_reminder.group_gap": "({{gap}}개 더 필요합니다)",
        "cart.promotion_reminder.group_green": "<span class=\"bundle-group-label bundle-group-green\">B 그룹</span> {{gap}}개 더 필요함",
        "cart.promotion_reminder.group_red": "<span class=\"bundle-group-label bundle-group-red\">A 그룹</span> {{gap}}개 더 필요함",
        "cart.promotion_reminder.item": "{{gap}}개 더 구매 시",
        "cart.promotion_reminder.multiple_step": "더 많이 할인 받기!",
        "cart.promotion_reminder.multiple_step.reward_campaign": "더 많은 리워드를 받으실 수 있습니다!",
        "cart.promotion_reminder.separator": ",",
        "cart.promotion_reminder.stackable": "많이 살수록 더 많은 돈을 아끼게 됩니다!",
        "cart.redeem_gift.has_items_selected": "사은품 신청에 <span>{{total_point}}</span> 포인트 사용, 남은 포인트 <span>{{rest_point}}</span>",
        "cart.redeem_gift.has_items_selected.insufficient_point": "사용 가능한 포인트를 <span>{{rest_point}}</span> 포인트 초과했습니다. 일부 사은품을 제거해 주세요",
        "cart.related_products.title": "이런 상품은 어떠세요?",
        "cart.share.btn.tooltip": "장바구니 링크 복사해서 공유하기",
        "cart.sl_cashback.gain_toast": "Cashback eligible",
        "cart.sl_cashback.lost_toast": "Cashback unavailable for this payment method",
        "cart.title": "장바구니",
        "checkout.auto_fill.popup.cancel": "취소",
        "checkout.auto_fill.popup.continue": "계속하기",
        "checkout.auto_fill.popup.error": "올바른 형식을 입력해 주세요",
        "checkout.auto_fill.popup.title": "빠른 결제를 위해 휴대폰 번호를 입력해 주세요",
        "checkout.auto_fill.toast.error": "이전 주문 기록이 없어 빠른 결제 정보를 불러올 수 없습니다.",
        "checkout.card_info_error": "카드 정보를 다시 확인한 후 재시도해 주세요",
        "checkout.card_type_not_support_error": "지원되지 않는 카드 종류입니다",
        "checkout.cart_over_limit_error": "한 번에 최대 100개 상품까지 구매 가능합니다. 수량을 조절하고 다시 주문해 주세요",
        "checkout.delivery_option.out_of_stock": "일부 상품의 재고가 부족하여 해당 매장을 선택할 수 없습니다. 다른 매장을 선택해 주세요",
        "checkout.delivery_option.title": "배송지 주소",
        "checkout.discount.applied_coupons": "적용된 혜택",
        "checkout.discount.applied_promotions": "적용된 혜택",
        "checkout.fields.add_new": "추가하기",
        "checkout.fields.delivery_method": "배송 방법",
        "checkout.fields.email": "메일 주소",
        "checkout.fields.email.hint": "메일 주소를 정확히 입력해 주세요. 주문 확인 및 안내 메일이 해당 주소로 발송됩니다",
        "checkout.fields.email.placeholder": "메일",
        "checkout.fields.out_of_stock": "죄송합니다. 선택하신 상품의 재고가 부족합니다. 해당 상품을 삭제한 후 다시 주문해 주세요",
        "checkout.fields.phone": "전화번호",
        "checkout.fields.phone.hint": "배송 상태 알림 SMS 수신을 위해 휴대폰 번호를 입력해 주세요.",
        "checkout.fields.phone.invali": "휴대폰 번호가 유효하지 않습니다",
        "checkout.fields.phone.invalid": "전화번호가 유효하지 않습니다",
        "checkout.fields.phone.placeholder": "전화번호",
        "checkout.fields.remarks": "주문 메모",
        "checkout.fields.remarks.placeholder": "스토어에게 전달할 메모를 입력해 주세요",
        "checkout.fields.select": "--선택--",
        "checkout.instalment_amount": "약 {{amount}} x {{period}}회 할부",
        "checkout.instructions": "주문 정보",
        "checkout.labels.promotion.coupon": "쿠폰",
        "checkout.labels.promotion.free_shipping": "무료 배송",
        "checkout.labels.promotion.membership": "멤버십 혜택",
        "checkout.labels.promotion.promotion": "프로모션",
        "checkout.payment_condition.continue_shopping": "쇼핑 계속하기",
        "checkout.payment_condition.description": " 주문 결제가 가능합니다. 장바구니로 돌아가 다른 결제 수단을 선택하거나 쇼핑을 계속해 주세요",
        "checkout.payment_condition.hint": "결제를 진행하기 위한 최소 주문 금액을 충족해야 합니다",
        "checkout.payment_condition.title": "{{difference}} 부족",
        "checkout.payment_failed": "결제에 실패했습니다. 다시 시도해 주세요",
        "checkout.payment_failed.atome.minamount": "주문 금액이 결제 수단 한도를 초과하거나 미달합니다. 장바구니 내용을 변경하거나 다른 결제 수단을 선택해 주세요",
        "checkout.payment_failed.check_credit_card_info": "카드 정보를 확인해 주세요. 입력한 정보가 정확하다면 카드 발급사에 승인 상태를 확인하거나 쇼핑몰에 문의해 주세요",
        "checkout.payment_method.title": "결제 정보",
        "checkout.payments.apple_pay.not_supported": "Apple Pay로 결제할 수 없습니다: <ul><li>기기 또는 브라우저가 Apple 계정에 로그인되어 있는지 확인해 주세요</li><li>Apple Pay 계정에 유효한 카드가 등록되어 있는지 확인해 주세요</li></ul>",
        "checkout.payments.exist.order.tip": "이미 생성된 주문 <a href=\"{{ duplicateOrderLink }}\">{ {{order}} }</a>이(가) 있습니다. 다시 결제하시려면 '주문 제출'을 클릭해 주세요.",
        "checkout.payments.google_pay.not_supported": "Google Pay로 결제할 수 없습니다: <ul><li>기기 또는 브라우저가 Google 계정에 로그인되어 있는지 확인해 주세요</li><li>Google Pay 계정에 유효한 카드가 등록되어 있는지 확인해 주세요</li></ul>",
        "checkout.payments_transaction_error": "거래 중 문제가 발생했습니다. 입력하신 결제 정보를 다시 확인하거나 카드 발급사에 문의해 주세요.",
        "checkout.promotion.tags.coupon": "쿠폰",
        "checkout.promotion.tags.free_shipping": "무료 배송",
        "checkout.promotion.tags.membership": "멤버십 혜택",
        "checkout.promotion.tags.promotion": "프로모션",
        "checkout.promotion.tags.subscription_promotion": "정기 배송 혜택",
        "checkout.recipient_name_invalid": "수령인 이름이 유효하지 않습니다. 공백이나 특수문자를 제외하고 10자 이내로 입력해 주세요",
        "checkout.recipient_phone_invalid": "수령인 전화번호가 유효하지 않습니다. 다시 확인해 주세요",
        "checkout.station_space_confirm_error": "점포 선택에 실패했습니다. 다시 시도하거나 고객센터에 문의해 주세요",
        "checkout.store_unavailable": "현재 해당 점포을 선택할 수 없습니다. 다른 점포을 선택해 주세요",
        "checkout.timeout": "결제 중 문제가 발생했습니다. 중복 주문이 발생할 수 있으니 결제 상태를 먼저 문의해 주세요",
        "checkout_object.detail.close": "닫기",
        "checkout_object.detail.title": "결제 금액 내역",
        "close": "닫기",
        "cookie_consent_popup.buttons.accept": "동의하고 계속하기",
        "cookie_consent_popup.buttons.save_preferences": "환경설정 저장",
        "cookie_consent_popup.buttons.settings": "환경설정",
        "cookie_consent_popup.claim.description": "안녕하세요! 본 웹사이트는 안정적인 서비스 제공을 위해 필수 쿠키와 추적형 쿠키를 사용합니다. 추적형 쿠키는 귀하의 동의가 있을 때만 실행됩니다.",
        "cookie_consent_popup.claim.heading": "쿠키 사용 안내",
        "cookie_consent_popup.claim.read_more": "자세히 보기",
        "cookie_consent_popup.cookie_descriptions.functionality": "이 쿠키는 귀하가 입력한 정보(사용자 이름, 언어, 위치 등)를 익명으로 저장하여 방문 시 맞춤 설정을 제공합니다. 이 쿠키를 거부할 경우 일부 기능을 이용하지 못할 수 있습니다.",
        "cookie_consent_popup.cookie_descriptions.marketing": "이 쿠키는 귀하의 관심사와 관련된 광고를 제공하고 마케팅 정보를 전달하는 데 사용됩니다. 해당 정보는 제3자 마케팅 플랫폼과 공유될 수 있습니다.",
        "cookie_consent_popup.cookie_descriptions.necessary": "웹사이트 운영을 위해 필수적인 쿠키이며 비활성화할 수 없습니다. 이 쿠키가 없으면 웹사이트가 정상적으로 작동하지 않습니다.",
        "cookie_consent_popup.cookie_descriptions.statistical": "이 쿠키는 웹사이트의 성능을 개선하고 더 나은 사용자 경험을 제공하기 위해 사용됩니다. 예를 들어, 방문자가 가장 자주 열어보는 페이지나 오류 메시지 발생 여부 등을 확인합니다. 이 쿠키는 개인을 식별할 수 있는 정보를 저장하지 않으며, 모든 정보는 익명으로 수집 및 요약됩니다. 이 쿠키를 허용하지 않으시면 귀하가 웹사이트를 어떻게 이용하시는지 확인할 수 없습니다.",
        "cookie_consent_popup.cookie_names.functionality": "기능 쿠키 허용",
        "cookie_consent_popup.cookie_names.marketing": "마케팅 쿠키 허용",
        "cookie_consent_popup.cookie_names.necessary": "필수 쿠키만 허용",
        "cookie_consent_popup.cookie_names.statistical": "통계용 쿠키 허용",
        "coupon.already_taken": "이미 받으신 쿠폰입니다",
        "coupon.back_to_cart_button": "장바구니로 이동",
        "coupon.close": "닫기",
        "coupon.comingSoon": "오픈 예정",
        "coupon.confirm": "확인",
        "coupon.congratulation": "쿠폰을 성공적으로 받으셨습니다!",
        "coupon.expired": "만료됨",
        "coupon.first_purchase_only": "첫 구매 한정",
        "coupon.first_purchase_only.with_platform": "{{platform}} 첫 구매 한정",
        "coupon.first_shoppers": "선착순 {{number}}명 적용",
        "coupon.invalid": "만료됨",
        "coupon.is_expired": "만료된 쿠폰입니다",
        "coupon.login": "로그인",
        "coupon.login_or_register": "아래 버튼을 클릭하여 로그인 또는 회원 가입하러 이동하세요",
        "coupon.login_to_receive": "로그인 후 쿠폰 받기",
        "coupon.no_available_coupon": "받을 수 있는 쿠폰이 없습니다",
        "coupon.no_comingSoon_coupon": "오픈 예정된 쿠폰이 없습니다",
        "coupon.no_invalid_coupon": "만료된 쿠폰이 없습니다",
        "coupon.no_valid_coupon": "사용 가능한 쿠폰이 없습니다",
        "coupon.not_eligible": "쿠폰 사용 대상이 아닙니다",
        "coupon.one_time": "1인당 1회 사용 한정",
        "coupon.online_and_selected_retail_store_only": "온라인 및 특정 오프라인 매장 전용",
        "coupon.online_store_only": "온라인 쇼핑몰 전용",
        "coupon.only_tag": "한정",
        "coupon.reach_limit": "쿠폰 소진",
        "coupon.retail_store_only": "오프라인 매장 전용",
        "coupon.select_coupon": "쿠폰 선택",
        "coupon.selected_retail_store_list": "특정 오프라인 매장 목록",
        "coupon.selected_retail_store_only": "특정 오프라인 매장 전용",
        "coupon.start_at": "쿠폰 시작일 <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">현지 시간대 기준<br/>(GMT{{timeZone}})</div> {{time}} </span>",
        "coupon.success": "성공적으로 받으셨습니다",
        "coupon.title": "쿠폰",
        "coupon.unfit_first_purchase": "첫 구매 전용 쿠폰 대상이 아닙니다",
        "coupon.usage_limit": "쿠폰 소진",
        "coupon.used": "사용됨",
        "coupon.valid": "사용 가능",
        "coupon.valid_until": "쿠폰 만료일 <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">현지 시간대 기준<br/>(GMT{{timeZone}})</div> {{time}} </span>까지",
        "coupon.view": "쿠폰 보기",
        "coupon_center": "쿠폰 센터",
        "coupon_center.empty": "받을 수 있는 쿠폰이 없습니다",
        "coupon_input.claim": "받기",
        "coupon_input.claim_failed": "쿠폰 받기 실패",
        "coupon_input.claim_succeed": "{{ couponName }} 쿠폰을 받으셨습니다!",
        "coupon_input.claim_succeed.redirect": "{{ couponName }} 쿠폰을 받으셨습니다! 마이페이지에서 확인해 보세요",
        "coupon_input.placeholder": "쿠폰 코드를 입력하세요",
        "coupon_v2.claim": "지금 받기",
        "coupon_v2.claim.success": "{{ name }} 쿠폰을 받으셨습니다",
        "coupon_v2.claimed": "받기 완료",
        "coupon_v2.copy_code": "쿠폰 코드 복사",
        "coupon_v2.copy_code.success": "복사됨",
        "coupon_v2.discount_type.discount": "할인 쿠폰",
        "coupon_v2.discount_type.free_shipping": "무료 배송 쿠폰",
        "coupon_v2.discount_type.gift": "사은품 쿠폰",
        "coupon_v2.first_purchase_only": "",
        "coupon_v2.first_purchase_with_platform": "",
        "coupon_v2.login_to_claim": "",
        "coupon_v2.no_quota": "",
        "coupon_v2.period.end_at": "{{ date }}까지 사용 가능",
        "coupon_v2.period.start_at": "{{ date }}부터 사용 가능",
        "coupon_v2.use": "지금 사용하기",
        "delivery.sfexpress.district": "SF 익스프레스 지역",
        "delivery.sfexpress.ef_locker": "SF 익스프레스 스마트 락커",
        "delivery.sfexpress.locker_location": "라커 위치",
        "delivery.sfexpress.store": "SF 익스프레스 주소",
        "delivery_address.district.hk": "구역 (District)",
        "delivery_address.district.th": "군",
        "delivery_address.district.tw": "구",
        "delivery_address.district.vn": "군/구",
        "delivery_address.province.th": "도 / 특별시/ 광역시",
        "delivery_address.province.vn": "도, 특별시, 광역시 / 시",
        "delivery_address.region.hk": "구",
        "delivery_address.region.tw": "도시/군",
        "delivery_address.store": "{{ station_name }} 점포",
        "delivery_address.street": "도로명/지번 주소",
        "delivery_address.ward.th": "구",
        "delivery_address.ward.vn": "동/면/리",
        "delivery_fee.pay.on.delivery": "배송비는 상품 수령 시 지불해 주세요",
        "delivery_options.fields.delivery_type": "물류 유형",
        "delivery_options.fields.delivery_types.custom": "직접 입력",
        "delivery_options.fields.delivery_types.email": "메일",
        "delivery_options.fields.delivery_types.international": "해외 배송",
        "delivery_options.fields.delivery_types.local": "국내 배송",
        "delivery_options.fields.delivery_types.pickup": "직거래 / 픽업",
        "delivery_options.fields.delivery_types.tw_simple_711": "7-11 픽업 (대만 한정)",
        "delivery_options.fields.delivery_types.tw_simple_familymart": "패밀리마트 픽업 (대만 한정)",
        "delivery_options.fields.select_date": "희망 배송일 선택",
        "dropdown.hint": "선택해 주세요",
        "dynamic.delivery.fee.calculate.desc": "기본 1kg 배송비 + (총 무게 - 1kg) * 추가 배송비",
        "dynamic.delivery.fee.calculate.hint": "총 무게가 1kg 미만인 경우 1kg로 계산됩니다",
        "dynamic.delivery.fee.calculate.info": "총 배송비: {{totalDeliveryFee}}",
        "dynamic.delivery.fee.calculate.title": "배송비 계산 방식",
        "dynamic.delivery.fee.no.state.info": "배송비는 배송 주소 확인 후 표시됩니다",
        "dynamic.delivery.fee.no.state.notice": "배송비는 배송 주소 입력 후 결제 페이지에서 확인하실 수 있습니다",
        "dynamic.delivery.fee.updated.notice": "배송비가 업데이트됐습니다",
        "error.401.description": "이 페이지에 접근할 권한이 없습니다",
        "error.401.title": "죄송합니다",
        "error.403.description": "이 페이지에 접근할 권한이 없습니다",
        "error.403.not_signed_in.anchor": "로그인",
        "error.403.not_signed_in.message": ", 로그인을 하지 않으셨기 때문일 수 있습니다",
        "error.403.title": "죄송합니다",
        "error.404.description": "페이지를 찾을 수 없습니다",
        "error.404.title": "죄송합니다",
        "error.continue": "쇼핑 계속하기!",
        "ezship.error.account_not_exist": "ezShip 계정이 존재하지 않습니다.",
        "ezship.error.invalid_amount": "금액이 올바르지 않습니다. ezShip 단일 주문 착불 금액 한도는 6,000 TWD입니다.",
        "ezship.error.invalid_email": "메일 형식 오류",
        "ezship.error.invalid_input": "내용이 올바르지 않거나 항목이 누락됐습니다",
        "ezship.error.invalid_mobile": "전화번호 형식 오류",
        "ezship.error.invalid_name": "수령인 성함이 올바르지 않거나 비어 있습니다",
        "ezship.error.invalid_store": "픽업 점포가 올바르지 않습니다",
        "ezship.error.no_easybag": "ezShip 계정에 사용 가능한 이지백(Easybag) 또는 미니백이 없습니다.",
        "ezship.error.no_permission": "ezShip 계정 권한이 부족합니다.",
        "ezship.error.system_error": "ezShip 시스템 오류입니다. 다른 배송 방법을 선택하거나 잠시 후 다시 시도해 주세요.",
        "facebook_banner.description": "현재 페이스북 앱 내 브라우저를 사용 중입니다. 이미지 업로드에 실패할 경우 다른 브라우저를 이용해 주세요. <span>여기를 클릭하여 링크 복사</span>.",
        "facebook_messenger_checkbox.subscribe": "메신저로 받기",
        "facebook_messenger_checkbox.subscribed": "구독 중",
        "facebook_messenger_checkbox.topics.MARKETING": "쇼핑몰 정보 및 프로모션 안내",
        "facebook_messenger_checkbox.topics.ORDER_STATUS_UPDATE,DELIVERY_STATUS_UPDATE": "주문 상태 알림",
        "facebook_messenger_checkbox.turn_off": "끄기",
        "facebook_messenger_checkbox.v2.subscribe": "메신저 구독",
        "facebook_messenger_checkbox.v2.subscribed": "메신저 구독 중",
        "fb_in_app_browser_popup.copy_link": "여기를 클릭하여 링크 복사.",
        "fb_in_app_browser_popup.desc": "현재 페이스북 인앱 브라우저를 사용 중입니다. 원활한 결제를 위해 다른 브라우저를 이용해 주세요. ",
        "form.action.delete": "삭제",
        "form.response.load.more.error": "데이터를 불러오지 못했습니다. 다시 시도해 주세요.",
        "form.validation.birthday.invalid": "올바르지 않은 생년월일입니다",
        "form.validation.birthday.invalid.minimum_age_limit": "올바르지 않은 생년월일입니다. {{minimumAgeLimit}}세 이상이어야 합니다.",
        "form.validation.birthday.required": "생년월일은 필수 항목입니다",
        "form.validation.calling_code": "국가 번호는 필수 입력 항목입니다",
        "form.validation.card.bin.error": "선택하신 결제 수단은 이 카드에서 지원되지 않습니다. 필요 시 판매자에게 문의해 주세요.",
        "form.validation.card.bin.error.unknow_scheme": "카드의 종류를 판별할 수 없습니다. 필요 시 판매자에게 문의해 주세요.",
        "form.validation.confirmation": "비밀번호가 일치하지 않습니다",
        "form.validation.delivery_option.country": "선택하신 배송 방법으로는 해당 국가/지역으로 배송이 불가합니다. 배송 주소를 변경하거나 다른 배송 방법을 선택해 주세요.",
        "form.validation.delivery_option.cross_border.MY": "선택하신 배송 방법으로는 {{ area == \"west\" ? \"서\" : \"동\" }}말레이시아로 배송이 불가합니다. {{ area == \"west\" ? \"동\" : \"서\" }}말레이시아 주소로 변경하거나 다른 배송 방법을 선택해 주세요.",
        "form.validation.delivery_option.local": "선택하신 배송 방법으로는 대만 본섬으로 배송이 불가합니다. 도서 지역 주소로 변경하거나 다른 배송 방법을 선택해 주세요.",
        "form.validation.delivery_option.outlying": "선택하신 배송 방법으로는 도서 지역으로 배송이 불가합니다. 대만 본섬 주소로 변경하거나 다른 배송 방법을 선택해 주세요.",
        "form.validation.delivery_option.region": "선택하신 배송 방법으로는 해당 지역으로 배송이 불가합니다. 주소를 변경하거나 다른 배송 방법을 선택해 주세요.",
        "form.validation.email": "{{field_name}}은(는) 유효하지 않습니다",
        "form.validation.email.duplicate": "이미 등록된 메일입니다. 다른 메일을 입력해 주세요.",
        "form.validation.email.hint": "유효한 메일 주소를 입력해 주세요",
        "form.validation.id_no": "안내: 통관고유부호 (PCCC)등 실명 인증 정보를 입력하지 않을 경우 통관에 지장이 있을 수 있습니다",
        "form.validation.invalid": "{{field_name}}은(는) 유효하지 않습니다",
        "form.validation.maxlength": "{{field_name}}이(가) 너무 깁니다",
        "form.validation.maxlength.with.number": "{{field_name}}은(는) 최대 {{ max_length }}자까지 입력 가능합니다",
        "form.validation.minlength": "{{field_name}}이(가) 너무 짧습니다",
        "form.validation.mobile.error": "{{field_name}}은(는) 유효하지 않습니다. 휴대폰 번호를 입력해 주세요",
        "form.validation.passport": "안내: 여권번호 등 실명 인증 정보를 입력하지 않을 경우 통관에 지장이 있을 수 있습니다",
        "form.validation.pattern": "{{field_name}}은(는) 유효하지 않습니다",
        "form.validation.pattern.711_cross_border.delivery_address": "해외 배송 서비스이므로 주소를 영어로 입력해야 합니다.",
        "form.validation.pattern.customer_name.user_name_invalid": "이름 형식이 올바르지 않습니다. 지원하지 않는 기호가 포함되어 있습니다",
        "form.validation.pattern.recipient-name": "공백이나 특수문자는 입력할 수 없으며, {{limit_length}}자를 초과할 수 없습니다",
        "form.validation.pattern.recipient-phone.TW": "{{field_name}}은(는) 10자리 숫자여야 합니다",
        "form.validation.pattern.recipient-phone.above_size": "수령인 전화번호는 {{ max_count }}자리 이상이어야 합니다",
        "form.validation.pattern.recipient-phone.beginning_stint": "수령인 전화번호는 {{ stint_charts.split(\",\").join(\" 또는 \") }}(으)로 시작해야 합니다",
        "form.validation.pattern.recipient-phone.fix_size": "수령인 전화번호는 {{ max_count }}자리 숫자여야 합니다",
        "form.validation.phone.error": "{{field_name}}은(는) 유효하지 않습니다. 다시 확인해 주세요",
        "form.validation.phone.required": "{{field_name}}은(는) 필수 항목입니다",
        "form.validation.policy": "이용 약관 및 개인정보 처리방침에 동의하셔야 합니다",
        "form.validation.required": "{{field_name}}은(는) 필수 항목입니다",
        "form.validation.unique": "이미 사용 중인 {{field_name}}입니다. 다시 입력해 주세요",
        "gift.exceed.limit": "선택하신 사은품 수량이 한도를 초과했습니다",
        "gift.items_needed.hint": "<span class=\"highlight-label\">{{ quantity }}</span>개를 더 추가하면 완료됩니다.",
        "gift.quantity_label.unqualified": "{{ quantity }}개 더 필요합니다",
        "gift.sold_out": "선택하신 사은품이 소진됐습니다",
        "gift.variation.confirm": "옵션 확인",
        "go_coupon_center": "쿠폰 센터로 이동",
        "hk_sfplus.address": "{{region}} {{district}} {{area}}",
        "hk_sfplus.area": "범위",
        "hk_sfplus.district": "구역",
        "hk_sfplus.region": "지역",
        "imagepicker.title": "이미지 업로드",
        "in_app_browser_popup.desc": "원활한 로그인 및 결제를 위해 기본 브라우저를 사용해 주세요.",
        "languages.en": "영어",
        "languages.id": "인도네시아어",
        "languages.jp": "일본어",
        "languages.vi": "베트남어",
        "languages.zh-hant": "중국어",
        "line_messenger_checkbox.button.unsubscribe": "해제",
        "line_messenger_checkbox.order_notification.subscribed": "주문 상태 알림 구독 중",
        "line_messenger_checkbox.subscribe": "LINE으로 받기",
        "line_messenger_checkbox.subscribed": "LINE 구독 중",
        "lock_inventory.locked_quantity_unit": "개",
        "lock_inventory.tooltip": "{{ endDateFormat }}까지 보관 가능\n({{ startDateFormat }} 부터 시작된 라이브: {{event_name}})\n\n현지 시간대 기준 (GMT{{timezone}})",
        "media.validation.error": "죄송합니다. 업로드 중 문제가 발생했습니다. 다시 시도해 주세요.",
        "media.validation.error.file_attachment_size": "2MB 이하의 파일만 업로드 가능합니다",
        "media.validation.error.file_size": "5MB 이하의 이미지만 업로드 가능합니다",
        "media.validation.file_limit.one": "이미지는 1장만 업로드할 수 있습니다",
        "media.validation.type": "JPEG 또는 PNG 형식의 이미지만 업로드 가능합니다",
        "member.center.load.more": "더 보기",
        "member.center.load.more.error": "데이터를 불러오지 못했습니다. 다시 시도해 주세요.",
        "member_point": "포인트",
        "member_points.display.expire_point": " 포인트 만료 예정일: ",
        "member_points.display.successive_expire_point": " 포인트가 순차적으로 만료 예정일: ",
        "member_points.earn_from_order_description": "",
        "member_points.equal_cash": "{{money}} 상당",
        "member_points.fields.auto_reward": "주문 번호 ",
        "member_points.fields.auto_reward_seconds": "로 포인트 지급됨",
        "member_points.fields.date": "날짜",
        "member_points.fields.expire": "만료",
        "member_points.fields.expired": "포인트 만료됨",
        "member_points.fields.expiry_date": "만료일",
        "member_points.fields.member_info_reward": "회원 정보 리워드 포인트",
        "member_points.fields.member_point_expired": "포인트 만료됨",
        "member_points.fields.product_review_reward": "주문 <a href=\"{{link}}\">{{ orderNumber }}</a>에 리뷰 남김",
        "member_points.fields.remarks": "포인트 변동 사유",
        "member_points.fields.revert_member_point": "포인트 환급; 주문 취소됨",
        "member_points.fields.revert_member_point.order_edit": "포인트 복구；수정된 주문 번호 ",
        "member_points.fields.revert_member_point.order_split": "포인트 복구；분할된 주문 번호 ",
        "member_points.fields.revert_member_point.return": "포인트 복구；주문 반품됨",
        "member_points.fields.revert_member_point.return_order_revert": "포인트 복구；반품 번호",
        "member_points.fields.successive_expire": " 이후 순차적 만료",
        "member_points.fields.value": "포인트",
        "member_points.no_data": "내역이 없습니다",
        "member_points.point_balance": "현재 보유 포인트",
        "member_points.point_history": "포인트 내역",
        "member_points.redeem_cash_and_earn_from_order_description": "",
        "member_points.redeem_cash_description": "",
        "member_points.rule": "포인트 규정 안내",
        "member_points.title": "회원 포인트",
        "member_points.unit": "포인트",
        "member_referral.code.copy_and_share": "링크를 복사하여 친구에게 공유해 보세요. 추천인과 친구 모두 적립금을 받으실 수 있습니다.",
        "member_referral.code.remarks": "이벤트 규정 안내",
        "member_referral.copy.link": "링크 복사",
        "member_referral.copy.link.success": "복사됨",
        "member_referral.discount": "회원 추천 혜택",
        "member_referral.generate.code": "추천 링크 생성",
        "member_referral.generate.code.success": "생성됨",
        "member_referral.rules": "이벤트 규정 안내",
        "member_referral.welcome_credit.popup.content": "친구 추천을 통해 {{reward_value}}원의 적립금이 지급됐습니다. 결제 시 사용하실 수 있습니다. 회원 가입 후 새로운 친구에게 추천 링크를 공유하면 추가 혜택을 받으실 수 있습니다.",
        "member_referral.welcome_credit.popup.continue": "확인 및 쇼핑 계속하기",
        "member_referral.welcome_credit.popup.title": "{{reward_value}} 적립금이 지급됐습니다",
        "membership.profile.check.code.error": "인증 코드가 올바르지 않습니다. 다시 입력하거나 재전송해 주세요.",
        "membership.profile.email_subscription.error": "메일 구독을 위해 먼저 메일 주소를 입력해 주세요.",
        "membership.profile.mobile.number.verified": "회원 휴대폰 인증이 완료되었으며, 식별을 위해 저장된 전화번호가 해당 번호로 대체됩니다",
        "membership.profile.sms_subscription.error": "SMS 구독을 위해 먼저 휴대폰 번호를 입력해 주세요.",
        "membership.profile.subscriptions.marketing.news": "쇼핑몰 정보 및 프로모션 안내",
        "membership.profile.subscriptions.messages.new": "스토어에서 새 메시지가 도착했습니다.",
        "membership.profile.subscriptions.none": "없음",
        "membership.profile.subscriptions.orders.comments.new": "스토어에서 주문 메모가 도착했습니다",
        "membership.profile.subscriptions.orders.update.status": "내 주문 상태 업데이트 알림",
        "membership.profile.verification_hint": "메일 주소를 변경하면 저장 후 인증이 필요합니다. 인증 완료 시 메일 주소가 {{unconfirmed_email}}(으)로 업데이트됩니다.",
        "messages.form.send": "전송",
        "model.credit_card.choose_card": "사용할 결제 카드를 선택해 주세요",
        "model.credit_card.subtitle": "카드 정보를 입력해 주세요",
        "model.credit_card.title": "카드 정보",
        "model.credit_card.use_new_card": "새 카드 사용",
        "model.slpayment.recurring_pay_agreement": "SHOPLINE은 향후 정기 결제를 위해 이번 거래 정보를 사용합니다. '제출' 클릭 시 <a href=\"https://shopline.tw/about/product_subscription_agreements\" target=\"_blank\" rel=\"noopener\">《정기 결제 카드 자동이체 약관》</a>에 동의하는 것으로 간주됩니다",
        "model.slpayment.security_agreement": "본 결제 서비스는 SHOPLINE Payments에서 제공하며, PCI-DSS 국제 카드사 연합 최고 등급 인증을 획득하여 안전한 거래를 지원합니다. 국내외 카드 결제가 가능합니다.",
        "model.update_credit_card_for_product_subscription.fail": "정기 결제 정보 설정에 실패했습니다. 다시 시도해 주세요.",
        "model.update_credit_card_for_product_subscription.success": "카드 정보가 성공적으로 업데이트됐습니다",
        "multi_checkout.add_new_store": "새 점포를 추가하기",
        "multi_checkout.cart_tag_unnamed": "(이름 없음)",
        "multi_checkout.change.payment_type.modal.cancel": "취소",
        "multi_checkout.change.payment_type.modal.confirm": "변경",
        "multi_checkout.change.payment_type.modal.description": "결제 수단을 변경하면 배송 방법 선택 및 배송 정보를 다시 입력해야 합니다.",
        "multi_checkout.change.payment_type.modal.title": "결제 수단 변경",
        "multi_checkout.checkout.delivery_time.description": "배송 시간 안내:",
        "multi_checkout.checkout.destination.title": "목적지",
        "multi_checkout.default_store": "기본 점포",
        "multi_checkout.delivery_attribute": "주문",
        "multi_checkout.delivery_section.cod": "착불",
        "multi_checkout.delivery_section.collapse.hint": "배송 안내 펼치기",
        "multi_checkout.delivery_section.country.label": "국가/지역",
        "multi_checkout.delivery_section.delivery_option.label": "배송 방법",
        "multi_checkout.delivery_section.empty_delivery_methods": "사용 가능한 방법 없음",
        "multi_checkout.delivery_section.ncod": "선불 (착불 아님)",
        "multi_checkout.delivery_section.payment_type.label": "결제 유형",
        "multi_checkout.delivery_section.title": "결제 유형 및 배송 방법 선택",
        "multi_checkout.destination_section.address_type.new": "새 주소",
        "multi_checkout.destination_section.delivery_type.label": "선택된 배송 방법: ",
        "multi_checkout.destination_section.dynamic_fee.hint": "배송비는 배송 주소 입력 후 표시됩니다",
        "multi_checkout.destination_section.pick_store.label": "점포 검색",
        "multi_checkout.destination_section.pick_store.store_address": "점포 주소",
        "multi_checkout.destination_section.pick_store.store_code": "선택된 점포 코드",
        "multi_checkout.destination_section.pick_store.store_name": "선택된 점포명",
        "multi_checkout.destination_section.title": "배송지 정보 입력",
        "multi_checkout.items.title": "장바구니",
        "multi_checkout.next_step": "다음 단계",
        "multi_checkout.promotions.title": "혜택",
        "multi_checkout.summary_section.check_payment_instructions": "결제 안내 확인",
        "multi_checkout.summary_section.confirm": "확인",
        "multi_checkout.summary_section.delivery_type.label": "배송 방법：",
        "multi_checkout.summary_section.expand_payment_instructions": "결제 안내 펼치기",
        "multi_checkout.summary_section.title": "주문 정보",
        "order": "주문",
        "order.billing_address.same": "배송 주소와 동일",
        "order.billing_address.title": "청구지 주소",
        "order.customer_email": "고객 메일",
        "order.customer_name": "고객 성함",
        "order.customer_phone": "고객 전화번호",
        "order.delivery_address.address_1": "주소",
        "order.delivery_address.city": "도시/군/구",
        "order.delivery_address.postcode": "우편번호",
        "order.delivery_address.state": "시/도/지역",
        "order.delivery_data.consignee_id_no": "수령인 통관고유부호 (PCCC) 또는 여권번호",
        "order.delivery_data.location_code": "점포 코드",
        "order.delivery_data.location_name": "점포 이름",
        "order.delivery_data.recipient_name": "수령인 성함",
        "order.delivery_data.recipient_phone": "수령인 전화번호",
        "order.delivery_data.scheduled_delivery_date": "희망 배송일 선택",
        "order.delivery_data.time_slot": "배송 시간대",
        "order.delivery_data.time_slot_key": "희망 배송 시간대 선택",
        "order.email": "메일 주소",
        "order.invoice.carrier_number": "바코드 번호",
        "order.invoice.mailing_address": "영수증 주소",
        "order.invoice.tax_id": "사업자등록번호",
        "order.payment_data.credit_card_number": "카드 번호",
        "order.payment_data.cvc": "보안코드 (CVC)",
        "order.payment_data.expiry_date": "유효 기간",
        "order.payment_data.holdername": "카드 소유자 이름",
        "order.payments.login.confirm": "로그인한 후 다시 결제하거나 카드 정보를 업데이트하세요.",
        "order_comment_and_message.general_error": "시스템 오류입니다. 스토어에게 문의하거나 잠시 후 다시 시도해 주세요",
        "order_comment_and_message.rate_limit_error": "오늘 메시지 전송 한도를 초과했습니다. 내일 다시 시도해 주세요",
        "orders": "주문",
        "orders.action.cancel": "주문 취소",
        "orders.action.checkout": "결제하기",
        "orders.action.confirm": "주문 확인",
        "orders.action.ship": "발송 완료로 표시",
        "orders.actions.title": "주문 상태 관리",
        "orders.comments.text.name": "메시지",
        "orders.comments.text.placeholder": "메시지를 입력해 주세요",
        "orders.comments.title": "스토어와 고객 간 주문 메시지",
        "orders.coupons": "축하합니다! 누리실 혜택은:  ",
        "orders.coupons.apply": "사용하기",
        "orders.coupons.invalid": "죄송합니다. 해당 쿠폰은 사용할 수 없습니다",
        "orders.coupons.invalid.order": "결제 전 유효하지 않은 쿠폰이나 코드를 삭제해 주세요",
        "orders.coupons.label": "쿠폰 코드",
        "orders.coupons.placeholder": "쿠폰 코드를 입력해 주세요",
        "orders.coupons.validation.minamount": "죄송합니다. 최소 결제 금액을 충족하지 않아 쿠폰을 사용할 수 없습니다.",
        "orders.delivery.title": "배송/물류 정보",
        "orders.fields.accept_terms": "이용 약관 및 개인정보처리방침에 동의합니다",
        "orders.fields.accept_terms.validation.required": "이용 약관 및 개인정보처리방침에 동의하셔야 합니다",
        "orders.fields.applied_member_point_redeem_to_cash": "포인트 차감",
        "orders.fields.applied_user_credits": "적립금 적용",
        "orders.fields.billing_address": "청구 주소",
        "orders.fields.billto": "청구서",
        "orders.fields.credits_earned_after_paid": "주문 완료 후 지급될 적립금 ",
        "orders.fields.customer": "고객",
        "orders.fields.customer.phone": "고객 전화번호",
        "orders.fields.customer_name": "고객 성함",
        "orders.fields.delivery_address": "배송지 주소",
        "orders.fields.delivery_address.remarks": "배송 메모",
        "orders.fields.delivery_data.family_mart_freeze.error.locale_code": "배송 지점는 필수 항목입니다@",
        "orders.fields.delivery_data.sl_logistics_yto_store.city_list.error": "배송 방식 오류가 발생했습니다. 페이지를 새로고침하거나 <a href=\"/cart\" class=\"alert-highlight\">이전 페이지로 돌아가 배송 방식을 변경</a>해 주세요",
        "orders.fields.delivery_data.sl_logistics_yto_store.family_mart.label": "패밀리마트",
        "orders.fields.delivery_data.sl_logistics_yto_store.seven_eleven.label": "세븐일레븐",
        "orders.fields.delivery_data.sl_logistics_yto_store.store.label": "점포",
        "orders.fields.delivery_data.sl_logistics_yto_store.store_dropdown.error": "주소 오류가 발생했습니다. 다시 선택해 주세요",
        "orders.fields.delivery_data.tw_ezship.location_code.hint": "점포 검색",
        "orders.fields.delivery_data.tw_ezship.location_code.label": "수령 점포 코드",
        "orders.fields.delivery_data.tw_ezship.location_name.label": "수령 점포명",
        "orders.fields.delivery_data.tw_ezship.recipient_name.label": "수령인",
        "orders.fields.delivery_data.tw_ezship.sn_id.label": "배송 번호",
        "orders.fields.delivery_data.tw_simple_711.location_code.label": "세븐일레븐 점포 코드",
        "orders.fields.delivery_data.tw_simple_711.location_name.label": "세븐일레븐 점포명",
        "orders.fields.delivery_data.tw_simple_711.recipient_name.label": "수령인",
        "orders.fields.delivery_data.tw_simple_familymart.location_code.label": "패밀리마트 서비스 번호 (점포 코드 아님)",
        "orders.fields.delivery_data.tw_simple_familymart.location_name.label": "패밀리마트 점포명",
        "orders.fields.delivery_data.tw_simple_familymart.recipient_name.label": "수령인",
        "orders.fields.delivery_description": "배송 방법 안내",
        "orders.fields.delivery_fee": "배송비",
        "orders.fields.delivery_fee_free": "무료 배송",
        "orders.fields.delivery_method": "배송 방법",
        "orders.fields.member_points": "포인트",
        "orders.fields.options.blacklist.erro": "",
        "orders.fields.options.blacklist.error": "해당 상품은 선택하신 배송 또는 결제 방식을 이용할 수 없습니다. 상품 정보를 다시 확인하시고 다른 옵션을 선택하거나 나누어서 주문해 주세요.",
        "orders.fields.order_custom_discount": "맞춤 할인 합계",
        "orders.fields.order_date": "주문 날짜",
        "orders.fields.order_delivery.arrived": "배송완료",
        "orders.fields.order_delivery.collected": "수령 완료",
        "orders.fields.order_delivery.pending": "배송 준비 중",
        "orders.fields.order_delivery.returned": "반품 수거 완료",
        "orders.fields.order_delivery.returning": "반품 진행 중",
        "orders.fields.order_delivery.shipped": "발송 완료",
        "orders.fields.order_delivery.shipping": "배송 중",
        "orders.fields.order_discount": "할인",
        "orders.fields.order_number": "주문 번호",
        "orders.fields.order_remarks": "고객 주문 메모",
        "orders.fields.order_status": "주문 상태",
        "orders.fields.payment_fee": "추가 수수료",
        "orders.fields.payment_instructions": "결제 안내",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_barcode": "편의점 바코드 1회 결제 한도는 20,000 TWD입니다.",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_cvs": "편의점 코드 1회 결제 한도는 30,000 TWD입니다.",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_webatm": "인터넷 뱅킹 1회 결제 한도는 30,000 TWD입니다",
        "orders.fields.payment_method.validation.limit_lowest.barcode": "거래 실패: 편의점 바코드의 최소 결제 금액은 30 TWD입니다",
        "orders.fields.payment_method.validation.limit_lowest.cvs": "거래 실패: 편의점 코드의 최소 결제 금액은 30 TWD입니다",
        "orders.fields.payment_method.validation.limit_maximum.barcode": "거래 실패: 편의점 바코드의 최대 결제 금액은 20,000 TWD입니다",
        "orders.fields.payment_method.validation.limit_maximum.cvs": "거래 실패: 편의점 코드의 최대 결제 금액은 20,000 TWD입니다",
        "orders.fields.payment_type": "결제 수단",
        "orders.fields.preorder_item": "예약 구매 상품",
        "orders.fields.product_subscription_period": "제{{period}}회",
        "orders.fields.remaining_member_points_without_balance": "이번에 {{ applied }} 포인트 사용",
        "orders.fields.rounding": "반올림",
        "orders.fields.status.cancelled": "취소됨",
        "orders.fields.status.completed": "구매 확정",
        "orders.fields.status.confirmed": "확인됨",
        "orders.fields.status.pending": "주문 처리 중",
        "orders.fields.status.received": "수령 완료",
        "orders.fields.status.returned": "반품 수거 완료",
        "orders.fields.status.returning": "반품 진행 중",
        "orders.fields.status.shipped": "발송 완료",
        "orders.fields.status.temp": "주문 처리 중",
        "orders.fields.subtotal": "소계",
        "orders.fields.total": "합계",
        "orders.fields.user_credits": "적립금",
        "orders.general.title": "주문 정보",
        "orders.index.action.view": "보기",
        "orders.index.no_records.action": "계속 쇼핑하기!",
        "orders.index.no_records.description": "이 쇼핑몰에서의 주문이 없습니다",
        "orders.index.no_records.title": "주문이 없습니다",
        "orders.index.title": "주문",
        "orders.invoices.carrier": "전자 영수증",
        "orders.invoices.carrier_type.member": "회원 전용 (영수증 정보가 메일로 발송됩니다)",
        "orders.invoices.carrier_type.mobile_barcode": "휴대폰 바코드",
        "orders.invoices.carrier_type.npc_barcode": "개인 인증 바코드",
        "orders.invoices.get_invoice": "영수증 신청",
        "orders.invoices.title": "영수증",
        "orders.member_point.fields.redeemed": "포인트로 사은품 신청됨",
        "orders.member_point.pos_settled_content": "오프라인 매장 주문 완료 후 약 {{ pending_days }}일 뒤 포인트가 지급됩니다.",
        "orders.member_point.settled_after_content": "상품 수령 후 {{ pending_days }}일 뒤 포인트가 지급됩니다.",
        "orders.member_point.settled_after_order_completed": "주문 완료 후 지급될 포인트 ",
        "orders.member_point.unit": "포인트",
        "orders.notifications.title": "주문 상태 알림",
        "orders.payment.title": "결제 정보",
        "orders.payment_slip.footer": "입력하신 입금 정보는 주문 확인용으로만 사용되며, 보안 기술로 암호화되어 보호되니 안심하고 결제해 주세요.",
        "orders.payment_slip.order_info.amount": "주문 금액",
        "orders.payment_slip.order_info.instructions": "입금 안내",
        "orders.payment_slip.order_info.read_more": "전체 설명 보기",
        "orders.payment_slip.upload_form.hint": "입금 확인 후, 최대한 빠르게 배송을 준비하겠습니다!",
        "orders.payment_slip.upload_form.image_input.change": "이미지 변경하기",
        "orders.payment_slip.upload_form.image_input.description": "이미지가 선명한지 확인해 주시고, 계좌 뒷 5자리, 입금 시간, 입금 금액이 포함되어야 합니다",
        "orders.payment_slip.upload_form.image_input.error": "이미지는 10MB 이하여야 합니다",
        "orders.payment_slip.upload_form.image_input.title": "이체 확인증 업로드",
        "orders.payment_slip.upload_form.message": "입금 관련 메모 입력",
        "orders.payment_slip.upload_form.message.error": "글자 수는 {{ n }}자를 초과할 수 없습니다",
        "orders.payment_slip.upload_form.notification": "최신 주문 상태를 확인하려면 구독해 주세요",
        "orders.payment_slip.upload_form.paid_time": "입금 시간 선택",
        "orders.payment_slip.upload_form.title": "이체 완료 후, 이체 확인증을 업로드해 주세요",
        "orders.payment_slip.uploaded.alert": "감사합니다. 이체 확인증이 업로드됐습니다. 최대한 빨리 확인해 드리겠습니다!",
        "orders.payment_slip.uploaded.notification": "최신 주문 정보를 받으려면 구독하세요",
        "orders.payment_slip.uploaded.order_link": "주문 확인",
        "orders.payment_slip.uploaded.paid_time": "입금 시간: ",
        "orders.payment_slip.uploaded.title": "고객님의 이체 내역입니다",
        "orders.payment_slip.uploaded.upload_time": "확인증 업로드 시간:",
        "orders.payment_slip.uploaded_without_login.hint": "로그인 후 상세 내역을 확인하실 수 있습니다",
        "orders.payment_slip.uploaded_without_login.title": "감사합니다! 이 주문의 입금 내역이 업로드됐습니다",
        "orders.products.title": "상품 상세 설명",
        "orders.promotion_coupons.placeholder": "쿠폰 코드를 입력해 주세요",
        "orders.promotion_type.bundle_amount": "골라담기 혜택 (정액 할인)",
        "orders.promotion_type.bundle_gift": "골라담기 혜택 (사은품)",
        "orders.promotion_type.bundle_group": "A+B 세트",
        "orders.promotion_type.bundle_group_amount": "A+B 세트 (정액 할인)",
        "orders.promotion_type.bundle_group_gift": "A+B 세트 (사은품)",
        "orders.promotion_type.bundle_group_percentage": "A+B 세트 (할인)",
        "orders.promotion_type.bundle_percentage": "골라담기 혜택 (할인)",
        "orders.promotion_type.bundle_pricing": "골라담기 혜택",
        "orders.promotion_type.buyandget_free": "구매 시 사은품 증정",
        "orders.promotion_type.buyandget_percentage": "구매 시 할인 혜택",
        "orders.promotion_type.buyandget_pricing": "구매 시 특가 혜택",
        "orders.promotion_type.coupon": "쿠폰 코드",
        "orders.promotion_type.credit_reward": "적립금 리워드",
        "orders.promotion_type.custom_discount": "맞춤 할인",
        "orders.promotion_type.earn_purchase_points": "포인트 적립",
        "orders.promotion_type.free_shipping": "무료 배송 혜택",
        "orders.promotion_type.member_point_redeem_gift": "사은품 신청 이벤트",
        "orders.promotion_type.membership_offer": "멤버십 혜택",
        "orders.promotion_type.point_reward": "포인트 리워드",
        "orders.promotion_type.promotion": "프로모션",
        "orders.promotion_type.reward_credit": "구매 금액별 적립금 지급",
        "orders.reward_credit.accumulated_auto_reward": "{{ credit_threshold }} 구매 시마다 {{ credit_value }} 적립금 지급",
        "orders.reward_credit.auto_reward": "{{ credit_threshold }} 이상 구매 시 {{ credit_value }} 적립금 지급",
        "orders.reward_credit.balance": "{{ auto_reward_balance }} 부족",
        "orders.reward_credit.earned_after_order_completed_faq": "본 이벤트는 상품 할인 후 금액을 기준으로 리워드가 계산됩니다. 주문이 완료되면 적립금이 지급되며, 다음 쇼핑 시 사용하실 수 있습니다!",
        "orders.reward_credit.faq": "지급된 적립금은 결제 완료 후 획득하며, 다음 주문 시 사용하실 수 있습니다!",
        "orders.reward_credit.value": "{{ credit_value }} 적립금",
        "orders.reward_point.earned_after_order_completed_faq": "본 이벤트는 상품 할인 후 금액을 기준으로 리워드가 계산됩니다. 주문이 완료되면 포인트가 지급되며, 다음 쇼핑 시 사용하실 수 있습니다!",
        "orders.reward_point.faq": "지급된 포인트는 주문 완료 후 획득하며, 다음 주문 시 사용하실 수 있습니다!",
        "orders.reward_point.value": "{{ point_value }} 포인트",
        "orders.show.check_order.description": "<a href=\"{{pagePath}}\"> 마이페이지 > 주문 관리 </a>에서 주문 확인 및 취소가 가능합니다",
        "orders.show.check_order.title": "주문 확인",
        "orders.show.customer_cancel_order.button.cancel": "주문 취소",
        "orders.show.customer_cancel_order.button.ok": "확인",
        "orders.show.customer_cancel_order.confirm.description.integrated": "취소 사유를 알려주시면 더 나은 서비스를 위해 노력하겠습니다!<br>취소가 완료되면 환불 절차가 진행됩니다. 다시 뵙기를 기대하겠습니다!",
        "orders.show.customer_cancel_order.confirm.description.non_integrated": "취소 사유를 알려주시면 더 나은 서비스를 위해 노력하겠습니다!<br>최대한 빠르게 처리해 드릴 테니 잠시만 기다려 주세요.",
        "orders.show.customer_cancel_order.confirm.failed.description": "다시 시도해도 실패할 경우, 하단의 '스토어와 고객 간 주문 메시지'를 통해 문의해 주세요.",
        "orders.show.customer_cancel_order.confirm.failed.title": "주문 취소에 실패했습니다. 다시 시도해 주세요",
        "orders.show.customer_cancel_order.confirm.loading.description": "처리 중입니다. 페이지를 닫거나 이전 페이지로 돌아가지 마세요.",
        "orders.show.customer_cancel_order.confirm.loading.title": "처리 중",
        "orders.show.customer_cancel_order.confirm.success.description": "취소가 완료되면 메일로 알려 드립니다. 감사합니다!",
        "orders.show.customer_cancel_order.confirm.success.title": "취소 신청이 접수됐습니다",
        "orders.show.customer_cancel_order.confirm.title": "정말로 주문을 취소하시겠습니까?",
        "orders.show.customer_cancel_order.reasons.change_item": "구매 상품을 변경하고 싶음",
        "orders.show.customer_cancel_order.reasons.change_mind": "단순 변심",
        "orders.show.customer_cancel_order.reasons.default": "취소 사유를 선택해 주세요",
        "orders.show.customer_cancel_order.reasons.expensive_price": "다른 곳보다 가격이 비쌈",
        "orders.show.customer_cancel_order.reasons.hint": "취소 사유",
        "orders.show.customer_cancel_order.reasons.incorrect_customer_info": "배송 또는 결제 정보 잘못 입력",
        "orders.show.customer_cancel_order.reasons.other": "기타 사유",
        "orders.show.customer_cancel_order.reasons.other.placeholder": "사유를 알려주시면 더 나은 서비스를 위해 노력하겠습니다!",
        "orders.show.customer_cancel_order.reasons.repeat_purchase": "중복 주문",
        "orders.show.customer_cancel_order.reasons.wait_too_long": "배송 지연",
        "orders.show.message.shipped.description": "",
        "orders.show.message.shipped.title": "주문하신 상품이 발송됐습니다.",
        "orders.show.message.thankyou.description": "",
        "orders.show.message.thankyou.title": "주문해 주셔서 감사합니다",
        "orders.show.thankyou.continue": "쇼핑 계속하기!",
        "payment.action.confirm": "확인",
        "payment.cc.cashier.footer": "결제 서비스 제공: SHOPLINE Payments",
        "payment.cc.cvc": "보안코드 (CVC)",
        "payment.cc.cvc.hint": "일반적으로 카드 뒷면에 기재된 마지막 3자리 숫자입니다",
        "payment.cc.cvc.placeholder": "보안코드 (CVC)",
        "payment.cc.expirydate": "유효 기간",
        "payment.cc.expirydate.placeholder": "2 자리 월/2자리 년",
        "payment.cc.fields.accept_terms": "이용 약관 및 개인정보처리방침에 동의합니다",
        "payment.cc.fields.accept_terms.validation.required": "이용 약관 및 개인정보처리방침에 동의하셔야 합니다",
        "payment.cc.holdername": "카드 소유자 이름",
        "payment.cc.holdername.hint": "카드에 기재된 이름과 동일해야 합니다",
        "payment.cc.holdername.placeholder": "카드 소유자 이름",
        "payment.cc.number": "카드 번호 (Visa / Master)",
        "payment.cc.number.placeholder": "카드 번호 (공백 없이 입력)",
        "payment.cc.tw.cashier.footer": "본 결제 서비스는 SHOPLINE Payments에서 제공하며, PCI-DSS 국제 카드사 연합 보안 인증의 최고 등급을 獲得하여 국내외 카드 결제에 대해 안전한 거래 서비스를 지원합니다.",
        "payment.cc.update.instructions": "카드 정보를 입력하여 업데이트해 주세요.",
        "payments.fields.types.allpay_barcode": "편의점 바코드 (AllPay)",
        "payments.fields.types.allpay_credit": "카드 (AllPay)",
        "payments.fields.types.allpay_cvs": "편의점 코드 (AllPay)",
        "payments.fields.types.allpay_webatm": "인터넷 뱅킹 (AllPay)",
        "payments.fields.types.asiapay": "카드 (Asiapay)",
        "payments.fields.types.bank_transfer": "무통장 입금 / ATM",
        "payments.fields.types.cash_on_delivery": "착불",
        "payments.fields.types.credit_card": "카드",
        "payments.fields.types.custom": "기타 결제 수단",
        "payments.fields.types.esun": "E.SUN 카드",
        "payments.fields.types.ezship": "편의점 착불 (ezShip)",
        "payments.fields.types.free_checkout": "0원 결제",
        "payments.fields.types.paypal": "카드 또는 PayPal",
        "payments.fields.types.paypal_express": "카드 또는 PayPal",
        "payments.fields.types.prizm": "카드 (Visa / Master)",
        "paypal.language": "ko_KR",
        "porduct_sales_sold_count.max": "누적 판매량 <b>9000만+</b>개 돌파",
        "porduct_sales_sold_count.than_10": "누적 판매량 <b>{{count}}+</b>개 돌파",
        "porduct_sales_sold_count.than_100": "누적 판매량 <b>{{count}}+</b>개 돌파",
        "porduct_sales_sold_count.than_1000": "누적 판매량 <b>{{count}}+</b>개 돌파",
        "porduct_sales_sold_count.than_10000": "누적 판매량 <b>{{digit5}}만+</b>개 돌파",
        "porduct_sales_sold_count.than_100000": "누적 판매량 <b>{{digit5}}만+</b>개 돌파",
        "porduct_sales_sold_count.than_1000000": "누적 판매량 <b>{{digit5}}만+</b>개 돌파",
        "porduct_sales_sold_count.than_10000000": "누적 판매량 <b>{{digit5}}만+</b>개 돌파",
        "product.add_to_cart": "장바구니 담기",
        "product.add_to_cart_fail": "장바구니가 가득 찼습니다!",
        "product.addon_products.add_to_cart.hint": "장바구니에 성공적으로 담겼습니다",
        "product.addon_products.errors.addon_product_out_of_stock": "추가 구매 상품 재고가 부족합니다",
        "product.addon_products.errors.larger_addon_product": "추가 상품의 수량은 주 상품의 수량을 초과할 수 없습니다",
        "product.addon_products.errors.main_product_out_of_stock": "주 상품 재고가 부족합니다",
        "product.addon_products.errors.out_of_stock": "{{title}} 재고 부족",
        "product.addon_products.errors.reached_max_purchase_quantity": "최대 구매 가능 수량은 {{ message }}개입니다",
        "product.addon_products.label": "추가 구매 상품",
        "product.addon_products.tips.limit_exceed": "수량 변경 시, 선택하신 추가 상품의 수량은 주 상품의 수량을 초과할 수 없습니다.",
        "product.amazon_product_review.show_more": "더 알아보기",
        "product.available_time_info.end.1": "상품이",
        "product.available_time_info.end.2": "에 판매 종료",
        "product.available_time_info.start.1": "상품이",
        "product.available_time_info.start.2": "에 판매 시작",
        "product.available_time_over": "에 판매 종료",
        "product.bundle_group_products.label": "A+B 세트",
        "product.bundled_products.label": "골라담기 혜택",
        "product.buy_now": "바로 구매",
        "product.buy_now.preorder.hint": "예약 판매 중인 상품입니다",
        "product.buy_together": "함께 구매",
        "product.buyandget.label": "구매 시 혜택",
        "product.coming_soon": "판매 예정",
        "product.gift.label": "사은품",
        "product.member_only": "회원 전용",
        "product.out_of_stock": "일시 품절",
        "product.page.add_to_cart_count": "<span class=\"order-detail-count\">{{count}}</span>개의 상품이 담겼습니다",
        "product.page.quantity": "수량",
        "product.page.subtotal": "소계",
        "product.page.title.product-info": "상품",
        "product.page.unit_price": "단가",
        "product.preorder_limit.hint": "구매 수량에는 일반 상품과 예약 상품이 모두 포함됩니다",
        "product.product_review.no_review": "아직 리뷰가 없습니다",
        "product.product_review.out_of_5_stars": " 점",
        "product.product_review.rating_source_amazon": "리뷰 출처: 아마존",
        "product.product_review.rating_source_shopline": "리뷰 출처: 본 쇼핑몰",
        "product.product_review.reviews": "리뷰",
        "product.product_review.stars": " 점",
        "product.set.open_variation": "상품 상세 설명 보기",
        "product.store_stock.check_stock": "픽업 가능 매장 확인",
        "product.subscription_product.label": "정기 배송",
        "product.tier_member_only": "{{tierName}} 전용",
        "product.view_less": "적게 표시",
        "product.view_more": "더 알아보기",
        "product_review_comments.modal.content.character": "글자 수",
        "product_review_comments.modal.content.character_hint": "리뷰 내용 {{ min_length }}자 이상",
        "product_review_comments.modal.content.img": "이미지",
        "product_review_comments.modal.content.img_hint": "최소 이미지 1장 업로드",
        "product_review_comments.modal.content.no_limit.character": "글자 수 제한 없음",
        "product_review_comments.modal.content.no_limit.img": "제한 없음",
        "product_review_comments.modal.content.no_limit.time": "시간 제한 없음",
        "product_review_comments.modal.content.time": "리뷰 남기는 시간",
        "product_review_comments.modal.content.time_hint": "주문 완료 후 {{ deadline_days }}일 이내 리뷰 남김",
        "product_review_comments.modal.title": "리뷰 리워드 규정",
        "product_review_comments.orders.back_to_my_account": "< 마이페이지로 돌아가기",
        "product_review_comments.orders.back_to_the_store": "쇼핑하러 가기",
        "product_review_comments.orders.comment": "내용",
        "product_review_comments.orders.comment_placeholder": "(선택) 상품은 맘에 드셨나요? 리뷰를 남겨 주세요!",
        "product_review_comments.orders.completed_all_reviews": "축하합니다! 모든 리뷰 작성을 완료했습니다!",
        "product_review_comments.orders.empty.title": "리뷰할 상품이 없습니다",
        "product_review_comments.orders.finished_review.desc.1": "리뷰를 남기시면 즉시 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.2": "{{ deadline }} 전까지 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.3": "{{ min_length }}자 이상의 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.4": "{{ deadline }} 전까지 {{ min_length }}자 이상의 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.5": "이미지를 첨부한 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.6": "{{ deadline }} 전까지 이미지를 첨부한 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.7": "{{ min_length }}자 이상 작성하고 이미지를 첨부한 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.8": "{{ deadline }} 전까지 {{ min_length }}자 이상 작성하고 이미지를 첨부한 리뷰를 남기시면 {{ value }} {{ type }}을(를) 드립니다!",
        "product_review_comments.orders.finished_review.desc.member_point": "이벤트 조건을 충족 시, 리뷰 보상으로 {{ value }} 포인트가 지급될 예정입니다.",
        "product_review_comments.orders.finished_review.desc.user_credit": "이벤트 조건을 충족할 경우, 리뷰 보상으로 {{ value }}원의 적립금이 지급될 예정입니다.",
        "product_review_comments.orders.finished_review.title": "리뷰를 남겨 주셔서 감사합니다!",
        "product_review_comments.orders.max_length_of_characters": "2000자 이내",
        "product_review_comments.orders.order_id": "주문 번호: ",
        "product_review_comments.orders.orders_to_view": "리뷰 작성 대기 주문",
        "product_review_comments.orders.purchased_date": "구매 날짜: ",
        "product_review_comments.orders.rate_other_order": "다른 주문 리뷰하기",
        "product_review_comments.orders.review": "리뷰",
        "product_review_comments.orders.send": "게시",
        "product_review_comments.orders.upload_image": "이미지 업로드 (최대 9장까지)",
        "product_review_comments.orders.write_a_review": "리뷰 작성",
        "product_review_entry.review_button_text": "리뷰",
        "product_review_entry.review_description_content": "이전 구매하신 상품은 어떠셨나요? 소중한 리뷰를 남겨주세요!",
        "product_review_entry.review_description_title": "리뷰를 기다리고 있습니다...",
        "product_review_entry.review_description_title.member_point": "리뷰를 기다리고 있습니다... 리뷰를 남기시면 {{ value }} 포인트를 받으실 수 있습니다!",
        "product_review_entry.review_description_title.user_credit": "리뷰를 기다리고 있습니다... 리뷰 작성 시 {{ value }}원의 적립금을 받으실 수 있습니다!",
        "product_set.add_to_cart": "장바구니 담기",
        "product_set.add_to_set": "세트에 추가",
        "product_set.build": "세트 상품 선택",
        "product_set.exceed_limit": "입력하신 수량이 세트 상품 구매 한도를 초과했습니다",
        "product_set.items_needed": "<span class=\"highlight-label\">{{ quantity }}</span>개 더 필요합니다",
        "product_set.items_needed.diff": "{{ currentQuantity }}개가 선택됐습니다. <span class=\"highlight-label\">{{ stillNeedQuantity }}</span>개를 더 선택하면 세트 혜택이 적용됩니다!",
        "product_set.items_needed.hint": "<span class=\"highlight-label\">{{ quantity }}</span>개를 더 추가하면 완료됩니다.",
        "product_set.items_selected": "<span class=\"highlight-label\">{{ quantity }}</span>개 선택됨",
        "product_set.no_items_selected": "선택된 상품이 없습니다. 위에서 상품을 선택해 세트에 추가해 주세요.",
        "product_set.not_enough_stock": "입력하신 수량이 재고를 초과했습니다",
        "product_set.not_enough_stock.please_remove": "상품 수량이 재고를 초과했습니다. 이 상품을 삭제해 주세요",
        "product_set.please_select": "상품 옵션을 선택해 주세요",
        "product_set.quantity": "세트 수량",
        "product_set.quantity_label.qualified": "{{ quantity }}개 선택됨",
        "product_set.quantity_label.unqualified": "{{ quantity }}개 더 필요합니다",
        "product_set.quick_cart.add_to_set": "세트에 추가",
        "product_set.reach_limit": "구매 한도 도달",
        "product_set.reach_limit.congrats": "{{ quantity }}개의 상품이 선택됐습니다. 세트 혜택이 적용됐습니다!",
        "product_set.set_includes": "세트 상품 구성: ",
        "product_set.sold_out": "",
        "product_set.special_offer": "세트 상품 혜택",
        "product_set.subtitle.qualified": "혜택이 적용됐습니다. 지금 바로 장바구니에 담으세요!",
        "product_set.subtitle.unqualified": "아래 상품을 추가해 보세요. <span class=\"highlight-label\">{{ quantity }}</span>개를 더 추가하면 장바구니에 담을 수 있습니다",
        "products.category.advance_filter.apply": "필터 적용",
        "products.category.advance_filter.clear": "삭제",
        "products.category.advance_filter.clear_all": "전체 삭제",
        "products.category.advance_filter.placeholder.max_price": "최대 금액",
        "products.category.advance_filter.placeholder.min_price": "최소 금액",
        "products.category.advance_filter.show_less": "적게 표시",
        "products.category.advance_filter.show_more": "더 보기",
        "products.category.advance_filter.tag.max_price": "≤ {{ max_price }}",
        "products.category.advance_filter.tag.min_price": "≥ {{ min_price }}",
        "products.category.advance_filter.tag.price_range": "{{ min_price }} ~ {{ max_price }}",
        "products.category.advance_filter.title": "필터",
        "products.category.advance_filter.type.brand": "브랜드",
        "products.category.advance_filter.type.color": "색상",
        "products.category.advance_filter.type.material": "소재",
        "products.category.advance_filter.type.price": "가격 ({{ currency }})",
        "products.category.advance_filter.type.size": "사이즈",
        "products.message.button_cancel": "취소",
        "products.message.button_ok": "확인",
        "products.message.title": "이 상품을 삭제하시겠습니까?",
        "products.purchase_limit_hint": "1인당 {{limit}}개까지 구매 가능",
        "products.purchase_limit_hint_can_not_purchase": "1인당 {{limit}}개까지 구매 가능, 이미 구매 한도에 도달했습니다",
        "products.quick_cart.add_to_cart": "장바구니 담기",
        "products.quick_cart.insufficient_point": "회원 포인트가 부족합니다. 일부 사은품을 제거해 주세요",
        "products.quick_cart.low_stock_hint": "입력하신 수량이 재고를 초과했습니다",
        "products.quick_cart.message": "고객센터",
        "products.quick_cart.messagetobuy": "구매를 원하시면 문의해 주세요.",
        "products.quick_cart.out_of_number_hint": "상품 수량이 부족합니다",
        "products.quick_cart.out_of_stock": "품절",
        "products.quick_cart.out_of_stock_hint": "상품 재고가 부족하여 장바구니에 담을 수 없습니다",
        "products.quick_cart.preorder_now": "바로 예약 구매하기",
        "products.quick_cart.quantity": "수량",
        "products.quick_cart.quantity_invalid": "수량이 유효하지 않습니다. 올바른 수량을 입력해 주세요.",
        "products.quick_cart.quantity_of_stock_hint": "현재 재고가 {{message}}개만 남아 있습니다",
        "products.quick_cart.reached_max_purchase_quantity": "최대 구매 가능 수량은 {{ message }}개입니다",
        "products.quick_cart.show_more": "상품 정보",
        "products.variant_selector.hide": "접기",
        "products.variant_selector.view_other_variations": "다른 {{count}}개 옵션 보기",
        "promotions.available_platform.app": "앱",
        "promotions.available_platform.ec": "쇼핑몰",
        "promotions.available_platform.only": "{{platform}} 전용",
        "promotions.available_platform.retail": "점포",
        "promotions.available_platform.selected_retail": "특정 점포",
        "promotions.exclude.items.hint.member_point": "포인트 차감",
        "promotions.exclude.items.hint.member_tier": "멤버십 등급별 기본 혜택",
        "promotions.exclude.items.hint.order_discount": "전 상품 할인 혜택",
        "promotions.exclude.items.hint.reward_campaign": "전 상품 리워드 이벤트",
        "promotions.exclude.items.hint.title": "최저가 상품으로 다음 혜택에서 제외됩니다: ",
        "promotions.exclude.items.hint.user_credit": "적립금 사용",
        "promotions.page.available_platform": "해당 플랫폼: ",
        "promotions.page.display_local_timezone": "현지 시간대 기준<br/>(GMT{{offset}})",
        "promotions.page.end_at": "<b class=\"local-datetime\">{{date}}</b>까지 혜택 종료",
        "promotions.page.first_purchase_only": "<b>첫 구매</b> 한정",
        "promotions.page.first_purchase_only.with_platform": "<b>{{platform}} 첫 구매</b> 한정",
        "promotions.page.gift_sold_out_tag": "SOLD OUT",
        "promotions.page.gifts_sold_out": "All free gifts have been claimed.",
        "promotions.page.redeem_gift.end_at": "이벤트 종료일 <b class=\"local-datetime\">{{date}}</b>",
        "promotions.page.redeem_gift.start_at": "이벤트 시작일 <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.start_at": "이벤트 시작일 <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.term.confirm": "확인",
        "promotions.page.term.default": "＊상품 이벤트 혜택은 장바구니 결제 시점에 계산됩니다.\n＊결제 시 이벤트 지정 결제 및 배송 수단을 선택해야 혜택이 적용됩니다.\n＊회원 전용 이벤트의 경우, 로그인을 해야 혜택이 적용됩니다",
        "promotions.page.term.title": "이용 약관",
        "promotions.page.view_gifts": "View free gifts",
        "promotions.section.discount_percentage.caption": "{{ value }}% 할인",
        "promotions.section.discount_summary.content": "{{ criteria }}{{ benefits }}",
        "promotions.section.discount_summary.criteria.bundle_amount": "특정 상품: {{ itemCount }}개 선택 시 {{ discountValue }} 정액 할인",
        "promotions.section.discount_summary.criteria.bundle_gift": "특정 상품: {{ itemCount }}개 선택 시 사은품 {{ discountValue }}개 ({{ giftName }}) 증정",
        "promotions.section.discount_summary.criteria.bundle_group": "특정 상품: <span class=\"bundle-group-label bundle-group-red\">A 그룹</span> {{ red_count }}개, <span class=\"bundle-group-label bundle-group-green\">B 그룹</span> {{ green_count }}개 선택 시 총 {{ total }}",
        "promotions.section.discount_summary.criteria.bundle_group.is_accumulated": ", 많이 살수록 더 많은 돈을 아끼게 됩니다!",
        "promotions.section.discount_summary.criteria.bundle_group.is_not_accumulated": ", 최대 1세트까지만 혜택이 적용됩니다.",
        "promotions.section.discount_summary.criteria.bundle_group_amount": "특정 상품: <span class=\"bundle-group-label bundle-group-red\">A 그룹</span> {{ red_count }}개, <span class=\"bundle-group-label bundle-group-green\">B 그룹</span> {{ green_count }}개 선택 시 {{ total }} 할인",
        "promotions.section.discount_summary.criteria.bundle_group_gift": "특정 상품: <span class=\"bundle-group-label bundle-group-red\">A 그룹</span> {{ red_count }}개, <span class=\"bundle-group-label bundle-group-green\">B 그룹</span> {{ green_count }}개 선택 시 사은품 {{ total }}개 ({{ giftName }}) 증정",
        "promotions.section.discount_summary.criteria.bundle_group_percentage": "특정 상품: <span class=\"bundle-group-label bundle-group-red\">A 그룹</span> {{ red_count }}개, <span class=\"bundle-group-label bundle-group-green\">B 그룹</span> {{ green_count }}개 선택 시 {{ total }}% 할인",
        "promotions.section.discount_summary.criteria.bundle_percentage": "특정 상품: {{ itemCount }}개 선택 시 {{ discountValue }}% 할인",
        "promotions.section.discount_summary.criteria.bundle_pricing": "특정 상품: {{ itemCount }}개 선택 시 총 {{ discountValue }}",
        "promotions.section.discount_summary.criteria.scope_discounted_products": "<b>특정 상품</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_products.content": "<b>특정 상품</b> <b>{{ condition_value }} 이상</b> 구매 시, ",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal": "<b>전체 주문</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal.content": "<b>전체 주문</b> <b>{{ condition_value }} 이상</b> 구매 시, ",
        "promotions.section.discount_summary.criteria.type_quantity": "{{ count }}개",
        "promotions.section.discount_summary.discount_value": "{{ type == \"amount\" ? \"정액 할인\" : \"할인\" }} <b>{{ type == \"amount\" ? currency : \"\" }}{{ value }}{{ type == \"percentage\" ? \"%\":\"\" }}</b>",
        "promotions.section.discount_summary.set.on_item": "<b>특정 상품</b> {{ discount_value }}",
        "promotions.section.discount_summary.set.on_order": "{{ criteria_on ? \"\" : \"<b>전체 상품</b>\" }} {{ discount_value }}",
        "purchase_limit_hint.purchasable": "1인당 {{limit}}개까지 구매 가능합니다. 현재 {{purchasable_qty}}개 더 구매하실 수 있습니다.",
        "recaptcha.language": "ko",
        "redirect.go_home_in_seconds": "{{seconds}}초 후 홈으로 이동합니다",
        "return_order.back_to_order_detail": "주문 상세 페이지로 돌아가기",
        "return_order.confirmation": "반품 신청 확인",
        "return_order.confirmation.refund_note": "실제 환불 금액은 판매자가 배송비 및 각종 할인 조건을 계산한 후 <a href=\"{{ link }}\">반품 내역 페이지</a>에 표시됩니다.",
        "return_order.confirmation.refund_question": "궁금한 점이 있으시면 <a id=\"js-contact-us\">고객센터</a>로 문의해 주세요",
        "return_order.coninue_shopping": "쇼핑 계속하기",
        "return_order.delivery_status.arrived": "배송완료",
        "return_order.delivery_status.no_return": "반송 안 함",
        "return_order.delivery_status.pending": "반품 진행 중",
        "return_order.delivery_status.return_collected": "반품 완료",
        "return_order.delivery_status.returned": "반품 수거 완료",
        "return_order.delivery_status.returning": "반품 진행 중",
        "return_order.detail.apply_date": "신청일",
        "return_order.detail.confirmation_emailed": "반품 확인 메일이 발송됐습니다",
        "return_order.detail.order_submitted": "반품 신청이 접수됐습니다!",
        "return_order.detail.return_order_no": "반품 번호",
        "return_order.fill_infomation": "반품 정보 입력",
        "return_order.form.agree_return_policy": "<a href=\"{{ link }}\" target=\"_blank\" rel=\"noopener\">반품/교환 정책</a>에 동의합니다",
        "return_order.form.submit": "반품 신청 제출",
        "return_order.form.validation": "반품/교환 정책에 동의하셔야 합니다",
        "return_order.inspect.status": "검수 상태",
        "return_order.inspect.status.fail": "검수 반려",
        "return_order.inspect.status.no_inspect": "검수 생략",
        "return_order.inspect.status.pass": "검수 완료",
        "return_order.inspect.status.pending": "검수 전",
        "return_order.order_number": "주문 번호 ",
        "return_order.payment_record.pending": "처리 중",
        "return_order.payment_status.pending": "환불 전",
        "return_order.payment_status.refunded": "환불 완료",
        "return_order.popup.failed.confirm": "확인",
        "return_order.popup.failed.content": "해당 배송 방법의 주문 금액 한도는 {{ amount }}원입니다. 배송 방법을 변경한 후 다시 반품 신청을 해주세요.",
        "return_order.popup.failed.title": "반품 신청 실패!",
        "return_order.prcie_amount": "금액",
        "return_order.product_name": "상품명",
        "return_order.quantity": "수량",
        "return_order.refund.amount": "환불 금액",
        "return_order.refund.date": "환불 날짜",
        "return_order.refund.record": "환불 내역",
        "return_order.return.total": "반품 합계",
        "return_order.return_delivery.delivery_option": "반품 배송 방법",
        "return_order.return_delivery.destination": "배송지",
        "return_order.return_delivery.info": "반품 정보",
        "return_order.return_delivery.optional": "선택 사항",
        "return_order.return_delivery.receiver_address": "반품자 주소",
        "return_order.return_delivery.receiver_name": "반품자 성함",
        "return_order.return_delivery.receiver_phone": "반품자 전화번호",
        "return_order.return_delivery.status": "반품 배송 상태",
        "return_order.return_payment.bank_account": "은행명 및 계좌번호",
        "return_order.return_payment.bank_transfer_placeholder": "XXX OO은행 xxxxxxxxxxxx",
        "return_order.return_payment.bank_transfer_return": "환불 계좌 정보 제공",
        "return_order.return_payment.custom_return": "기타 (환불 관련 사항은 쇼핑몰에게 문의해 주세요)",
        "return_order.return_payment.info": "환불 정보",
        "return_order.return_payment.payment_option": "환불 수단",
        "return_order.return_payment.status": "환불 상태",
        "return_order.return_quantity": "반품 수량",
        "return_order.return_reason": "반품 사유",
        "return_order.return_reason.admin_return_order": "판매자가 반품 신청 직접 생성 ",
        "return_order.return_reason.broke_during_delivery": "배송 중 상품 파손",
        "return_order.return_reason.not_expected": "상품이 기대와 다름",
        "return_order.return_reason.other": "기타 사유",
        "return_order.return_reason.return_remark": "반품 사유 상세 내용",
        "return_order.return_reason.return_remark_placeholder": "단순 변심 등 (60자 이내)",
        "return_order.return_reason.wrong_item": "오배송",
        "return_order.return_reason.wrong_variation": "옵션(사이즈 등) 불일치",
        "return_order.select_return_product": "반품 상품 선택",
        "return_order.status": "반품 신청 상태",
        "return_order.status.cancelled": "반품 취소",
        "return_order.status.completed": "반품 완료",
        "return_order.status.confirmed": "반품 완료",
        "return_order.status.pending": "반품 검토 중",
        "return_order.unit_price": "단가",
        "save_fields.customer_info.birthday": "고객 생년월일",
        "saved_stores.update.failure": "업데이트에 실패했습니다. 다시 시도해 주세요.",
        "session.forget_passowrd.check_phone.error": "휴대폰 번호가 유효하지 않습니다. 다시 확인해 주세요",
        "session.forget_passowrd.error": "메일 또는 휴대폰 번호가 유효하지 않습니다",
        "session.forgot_password": "비밀번호 찾기",
        "session.login.success": "로그인 성공",
        "session.mobile_center.check_phone.error": "이미 가입된 휴대폰 번호입니다",
        "session.mobile_signup.check_mobile.go_back.1": "휴대폰 번호가 잘못된 경우 이전 단계로 돌아가 수정해 주세요",
        "session.mobile_signup.check_mobile.go_back.2": "이전 단계",
        "session.mobile_signup.check_mobile.go_back.3": "수정",
        "session.mobile_signup.check_mobile.go_back.3.simplified": "수정",
        "session.mobile_signup.check_mobile.send_code": "인증 코드 발송",
        "session.mobile_signup.check_mobile.title": "휴대폰 번호가 정확한지 확인해 주세요. 아래 번호로 SMS를 발송합니다",
        "session.mobile_signup.check_mobile.your_number": "휴대폰 번호",
        "session.mobile_signup.check_mobile.your_number.hint": "대만 휴대폰 번호를 입력해 주세요 (09로 시작)",
        "session.mobile_signup.go_back": "뒤로가기",
        "session.mobile_signup.input_code.hint": "수신된 SMS 인증 코드를 입력해 주세요",
        "session.mobile_signup.input_code.hint.simplified": "수신된 인증 코드를 입력해 주세요",
        "session.mobile_signup.input_code.placeholder": "인증 코드",
        "session.mobile_signup.input_code.resend": "인증 코드 재발송",
        "session.mobile_signup.input_code.resend.countdown": "인증 코드 재발송 전 ({{resendCountdown}} 초)",
        "session.mobile_signup.input_code.resend.countdown.simplified": "재발송 전 ({{resendCountdown}} 초)",
        "session.mobile_signup.input_code.resend.simplified": "재발송",
        "session.mobile_signup.input_code.submit": "제출",
        "session.mobile_signup.recaptcha.checkbox.error": "reCAPTCHA 테스트 통과 후 인증 코드가 발송됩니다",
        "session.mobile_signup.recaptcha.load.failure": "Google reCAPTCHA를 불러오지 못했습니다. 네트워크 상태를 확인한 후 다시 시도해 주세요.",
        "session.mobile_signup.recaptcha.token.failure": "시스템 오류가 발생했습니다. 네트워크 상태를 확인한 후 다시 시도해 주세요.",
        "session.signin.facebook": "페이스북 로그인",
        "session.signin.submit": "로그인",
        "session.signin.title": "로그인",
        "session.signup.facebook": "페이스북 가입하기",
        "session.signup.success": "회원 가입이 완료되어 자동으로 로그인됐습니다",
        "session.signup.title": "신규 회원 가입하기",
        "session.terms": "가입 시 사이트의 개인정보처리방침, 이용약관 및 세부 규칙에 동의하시는 것으로 간주됩니다.",
        "session.terms.facebook": "페이스북으로 가입하기",
        "sessions.or": "또는",
        "sms_messenger_checkbox.subscribe": "SMS 구독하기",
        "store_credits.bulk_imported": "수동으로 적립금 지급",
        "store_credits.credit_balance": "현재 보유 적립금",
        "store_credits.credit_history": "적립금 내역",
        "store_credits.fields.auto_reward": "지급될 적립금 ",
        "store_credits.fields.auto_reward_prefix": "주문",
        "store_credits.fields.balance": "적립금 잔액",
        "store_credits.fields.birthday_credit": "생일 적립금",
        "store_credits.fields.date": "날짜",
        "store_credits.fields.display.never_expired": "만료일 없음",
        "store_credits.fields.expiry_date": "만료일",
        "store_credits.fields.member_info_quick_completion_credit": "회원 정보 리워드 적립금",
        "store_credits.fields.member_referral_credit": "신규 고객 추천",
        "store_credits.fields.never_expires": "만료일 없음",
        "store_credits.fields.never_expires_point": " 포인트 만료일 없음",
        "store_credits.fields.order_prefix": "적립금을 사용된 주문 번호: ",
        "store_credits.fields.product_review_reward": "주문 <a href=\"{{link}}\">{{ orderNumber }}</a>에 리뷰 남김",
        "store_credits.fields.remarks": "적립금 항목",
        "store_credits.fields.revert_credit": "적립금 환급；주문 취소됨",
        "store_credits.fields.revert_credit.order_edit": "적립금 환급；수정된 주문 번호 ",
        "store_credits.fields.revert_credit.order_split": "적립금 환급；분할된 주문 번호 ",
        "store_credits.fields.revert_credit.return": "적립금 환급；주문 반품됨",
        "store_credits.fields.revert_credit.return_order_revert": "적립금 환급；반품 번호",
        "store_credits.fields.user_credit_expired": "적립금 만료",
        "store_credits.fields.value": "적립금 상당 금액",
        "store_credits.fields.welcome_credit": "신규 가입 적립금",
        "store_credits.fields.welcome_member_referral_credit": "추천 링크를 통해 가입 성공",
        "store_credits.no_data": "내역이 없습니다",
        "store_credits.title": "쇼핑몰 적립금",
        "store_stock.available": "온라인 구매하여 매장 픽업 가능",
        "store_stock.current_availability": "현재 매장 재고 현황",
        "store_stock.description": "상품 판매는 현장 상황에 따라 달라질 수 있습니다. 예약 완료 고객을 위해 재고를 보관하오니, 방문 전 주문을 완료하고 픽업 날짜를 확인해 주세요.",
        "store_stock.loading": "재고 확인 중",
        "store_stock.sold_out": "품절",
        "store_stock.take_a_while": "잠시만 기다려 주세요...",
        "subscribe.facebook.dialog.cancel": "취소",
        "subscribe.facebook.dialog.info": "페이스북 메신저 정책 변경에 따라 메신저에서 구독 절차를 완료해야 합니다. \"구독하러 가기\"를 누르면 메신저가 자동으로 열립니다.<br />메신저가 열리면 로그인 후 <span class=\"facebook-subscription-dialog-hint\">대화창에서 \"시작하기\" 버튼을 누른 다음에</span> 이 페이지로 돌아오면 구독이 완료됩니다. (쇼핑몰과 대화한 적이 있다면 메신저 실행 즉시 구독 처리됩니다.)",
        "subscribe.facebook.dialog.subscribe": "구독하러 가기",
        "subscribe.facebook.dialog.title": "페이스북 구독",
        "subscribe.facebook.failure": "구독 실패, 페이스북에 다시 로그인해 주세요",
        "subscribe.failure": "구독 실패, 쇼핑몰에 문의해 주세요",
        "subscribe.failure.already_bound": "구독 실패, 이 SNS 계정은 이미 다른 고객과 연동되어 있습니다. 쇼핑몰에 문의하여 해제해 주세요",
        "subscribe.line.failure": "구독 실패, LINE에 다시 로그인해 주세요",
        "subscribe.line.failure.already_used": "구독 실패, 이 LINE계정은 이미 다른 회원이 사용 중입니다. LINE으로 해당 계정에 로그인 후 다시 시도해 주세요",
        "subscribe.line.failure.different_id": "구독 실패, 가입 시 사용한 LINE계정으로 구독해 주세요",
        "subscribe.success": "구독 성공",
        "tax.applied_store_credit": "적립금 사용",
        "tax.calculate_tax": "세금 계산",
        "tax.calculate_tax.info.1": "먼저",
        "tax.calculate_tax.info.2": "클릭 후 결제해 주세요.",
        "tax.calculation_content": "(과세 대상 상품 총액 - 할인) * 세율 + 배송비 * 세율",
        "tax.calculation_title": "세금 계산 방식: ",
        "tax.delivery_tax": "배송비 세금",
        "tax.delivery_tax_rate": "배송비 세율",
        "tax.discounts": "혜택",
        "tax.fee": "세금",
        "tax.price_updated": "가격이 업데이트됐습니다.",
        "tax.product_price": "상품 가격",
        "tax.sales_tax": "소비세",
        "tax.sales_tax_rate": "소비세율",
        "tax.service_tax": "서비스세",
        "tax.service_tax_rate": "서비스세율",
        "tax.total": "합계",
        "tcat.time_slot.01": "13:00 이전",
        "tcat.time_slot.02": "14:00 - 18:00",
        "tcat.time_slot.04": "시간대 지정 없음",
        "tcat.time_slot.title": "희망 배송 시간대 선택",
        "trial_order_dialog.checkout": "결제 시작",
        "trial_order_dialog.content": "회원 가입, 혜택 알림 구독, 장바구니 추가 구매 등 강력한 기능을 제공합니다. 주문 한도에 도달하면 업그레이드를 통해 제한을 해제할 수 있습니다.",
        "trial_order_dialog.reach_limit.check_plan": "홈으로 돌아가 계속 쇼핑하기",
        "trial_order_dialog.reach_limit.content": "정식 오픈 후에 구매 및 결제가 가능합니다!<br/>운영에 궁금한 점이 있으시면 판매자에게 문의해 주세요.",
        "trial_order_dialog.reach_limit.continue": "쇼핑몰에게 문의하기",
        "trial_order_dialog.reach_limit.title": "시범 운영 주문 한도 도달",
        "trial_order_dialog.title": "결제 프로세스를 체험해 보세요. 시범 운영 중에는 최대 10건의 테스트 주문이 가능합니다",
        "unsubscribe.failure": "구독 취소 실패, 다시 시도해 주세요",
        "unsubscribe.success": "구독 취소됨",
        "user.add_credit_card": "카드 추가",
        "user.add_credit_card.cancel": "취소",
        "user.add_credit_card.fail": "카드 추가 실패, 다시 시도해 주세요",
        "user.add_credit_card.remind": "안내: 카드 등록 시 SHOPLINE Payments를 통해 {{ label }}원 결제 승인 테스트가 진행되며, 실제 금액은 청구되지 않습니다.",
        "user.add_credit_card.submit": "제출하기",
        "user.add_credit_card.success": "카드가 성공적으로 등록됐습니다",
        "user.credit_card.expired": "만료된 카드입니다",
        "user.credit_card.system.error": "시스템 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
        "user.credit_card_list.delete": "삭제",
        "user.credit_card_list.processing": "등록 중",
        "user.delete_credit_card": "이 카드를 삭제하시겠습니까?",
        "user.delete_credit_card.cancel": "취소",
        "user.delete_credit_card.delete": "삭제 확인",
        "user.delete_credit_card.description": "삭제하면 이 카드로 빠른 결제할 수 없습니다",
        "user.delete_credit_card.description.with_subscription_product": "삭제하면 이 카드로 빠른 결제할 수 없습니다. 이 카드로 정기 배송 상품을 구매하신 경우, 다음 주문 생성 시 결제 실패가 발생할 수 있습니다. 실패 시 마이페이지 > 주문 페이지에서 다시 결제해 주세요",
        "user.delete_credit_card.fail": "삭제 실패, 다시 시도해 주세요",
        "user.delete_credit_card.success": "카드를 성공적으로 삭제됐습니다",
        "user.delivery_data.recipient_phone": "수령인 전화번호",
        "user.quick_signup.error.confirmed": "이미 등록된 휴대폰 번호입니다.",
        "user.quick_signup.error.confirmed.url": "로그인하기",
        "user.quick_signup.error.format": "휴대폰 번호 형식이 올바르지 않습니다",
        "user.quick_signup.policy": "사이트의 ",
        "user.quick_signup.policy.url_content": "이용 약관 및 개인정보처리방침에 동의합니다",
        "user.quick_signup.policy_with_age": "본인은 사이트 <a href=\"{{ link }}\">이용 약관 및 개인정보 처리방침</a>에 동의하며, 만 {{ age }}세 이상입니다",
        "user.quick_signup.promotion": "최신 소식과 프로모션 알림 받기",
        "user.quick_signup.submit": "회원 가입 바로가기!",
        "user.quick_signup.title": "회원 가입",
        "user.quick_signup.title.content": "특별한 혜택을 놓치지 마세요!",
        "user.quick_signup.validate.finish_hint": "가입을 완료하면 로그인하여 적립금을 확인하거나 사용할 수 있습니다.",
        "user.quick_signup.validate.hint.password": "최소 8자 이상",
        "user.quick_signup.validate.hint.resend": "SMS를 받지 못하셨나요? 인증 코드 재전송",
        "user.quick_signup.validate.hint.send": "SMS가 발송됐습니다. {{count}}초 후 재전송 가능합니다",
        "user.quick_signup.validate.modify": "수정",
        "user.quick_signup.validate.phone": "인증하기",
        "user.quick_signup.validate.placeholder.name": "성함",
        "user.quick_signup.validate.placeholder.password": "비밀번호 설정",
        "user.quick_signup.validate.placeholder.sms": "인증 코드 입력",
        "user.quick_signup.validate.previous": "이전 단계",
        "user.quick_signup.validate.send.sms": "인증 SMS 발송",
        "user.quick_signup.validate.submit": "가입 완료",
        "user.quick_signup.validate.success": "회원 가입이 완료됐습니다!<br/>회원 정보를 계속 입력하거나<br/>또는 ",
        "user.quick_signup.validate.success.shop": "먼저 둘러보기",
        "user.quick_signup.validate.title": "가입 계속하기",
        "user.quick_signup.validate.wrong.number": "휴대폰 번호가 잘못된 경우 이전 단계로 돌아가 수정해 주세요",
        "user.sign_up.check_phone.error": "원 휴대폰 번호와 같습니다. 변경할 번호를 다시 입력해 주세요",
        "user.sign_up.email_verification.dialog.confirm": "확인",
        "user.sign_up.email_verification.dialog.description": "즉시 메일 인증을 완료하면 메일이 업데이트됩니다! 메일을 받지 못한 경우 메일 주소를 다시 변경하여 저장해 주세요",
        "user.sign_up.email_verification.dialog.title": "{{mail}}로 인증 메일이 발송됐습니다",
        "user_credit": "적립금",
        "user_reminder.coupon.action": "지금 받기",
        "user_reminder.coupon.guest": "로그인 후 쿠폰을 받아보세요!",
        "user_reminder.coupon.member": "아직 받지 않은 쿠폰이 있습니다. 지금 확인해 보세요!",
        "user_reminder.coupon.v2.desktop": "",
        "user_reminder.coupon.v2.mobile": "",
        "user_reminder.member_referral.action": "회원 가입 바로가기",
        "user_reminder.member_referral.member_point": "회원 가입 시 {{ value }}점의 포인트가 지급됩니다.",
        "user_reminder.member_referral.user_credit": "회원 가입 시 {{ value }}원의 적립금이 지급됩니다.",
        "users.add.delivery_address": "배송지 추가",
        "users.add.delivery_address.maximum": "배송지는 최대 5개까지 저장할 수 있습니다",
        "users.add.phone": "연락처 추가",
        "users.add.phone.maximum": "전화번호는 최대 5개까지 등록 가능합니다",
        "users.birthday.faq": "쇼핑몰 가입 및 쇼핑을 위해서는 일정 연령 이상이어야 합니다.",
        "users.edit_member_info": "회원 정보 수정",
        "users.einvoice_carrier": "전자영수증 수단 통합 관리",
        "users.error.maxlength": "이(가) 너무 깁니다",
        "users.error.no_changes": "저장할 변경 사항이 없습니다",
        "users.error.not_save_mobile_phone": "휴대폰 번호가 인증되지 않아 변경 사항을 저장할 수 없습니다",
        "users.error.phone.format": "전화번호 형식 오류",
        "users.error.phone.required": "전화번호는 필수 입력 항목입니다",
        "users.fields.callingCode": "국가 번호",
        "users.fields.callingCodeHint": "국가 번호를 선택해 주세요.",
        "users.fields.email": "메일",
        "users.fields.email.placeholder": "메일",
        "users.fields.mobile": "휴대폰 번호",
        "users.fields.mobile.placeholder": "휴대폰 번호",
        "users.fields.mobile_phone_or_email": "메일 또는 휴대폰 번호",
        "users.fields.name": "사용자 이름",
        "users.fields.name.placeholder": "사용자 이름",
        "users.fields.password": "비밀번호",
        "users.fields.password.placeholder": "비밀번호",
        "users.member.normal-level": "일반 회원",
        "users.membership.all.spending_single_purchase": "1회 소비액 {{spending}} 달성",
        "users.membership.all.spending_within_months": "{{months}}개월 내 누적 소비액 {{spending}} 달성",
        "users.membership.all_tiers": "모든 회원 등급 규정 보기",
        "users.membership.all_tiers.condition": "회원 등급 규정",
        "users.membership.all_tiers.description": "멤버십 기간 내 등급 유지 조건을 충족하지 못할 경우 자동으로 강등됩니다",
        "users.membership.expire.month_valid": "(유효 기간 {{months}}개월)",
        "users.membership.expire.unlimited": "영구 유효",
        "users.membership.expiry_date": "멤버십 만료일",
        "users.membership.extend_valid_period": "멤버십 유효기간 {{months}}개월 내 {{ type === \"within_interval\" ? \"누적\" : \"1회\" }} 소비액 {{spending}} 달성",
        "users.membership.extension.condition": "멤버십 유지 조건: ",
        "users.membership.extension.status": "멤버십 유지 상태: ",
        "users.membership.forget_password.email_sent": "계정 인증 메일을 {{email}}(으)로 발송했습니다.\n비밀범호를 재설정하려면 메일을 확인하세요.",
        "users.membership.max_level_tier": "최고 등급 회원이 되신 것을 축하합니다!",
        "users.membership.member_info.birthday": "생일",
        "users.membership.member_info.coupons": "{{count}}장의 쿠폰",
        "users.membership.member_info.email": "메일",
        "users.membership.member_info.gender": "성별",
        "users.membership.member_info.hint": "다음 회원 정보({{fields}}) 입력하시면 {{rewards}}을(를) 받으실 수 있습니다",
        "users.membership.member_info.member_points": "{{count}} 회원 포인트",
        "users.membership.member_info.mobile": "휴대폰 번호",
        "users.membership.member_info.name": "성함",
        "users.membership.member_info.sent": "정보 확인 완료되면 회원 정보 리워드를 지급됩니다!",
        "users.membership.member_info.symbol": ", ",
        "users.membership.member_info.title": "회원 정보 리워드",
        "users.membership.member_info.user_credits": "${{count}} 적립금",
        "users.membership.offer.discount": "전용 혜택",
        "users.membership.spending_single_purchase": "1회 소비액 {{spending}} 달성 시 승급 가능",
        "users.membership.spending_within_months": "{{months}}개월 내 누적 소비액 {{spending}} 달성 시 승급 가능",
        "users.membership.tier.expire.date": "유효 기간: ",
        "users.membership.tier.expire.date.auto_downgrade.description": "주문 상태가 \"완료\"로 전환된 다음 날 새벽에 자동 업데이트됩니다. 주문 취소 또는 반품으로 승급 조건을 충족하지 못할 경우 승급되지 않습니다.",
        "users.membership.tier.expire.date.description": "결제가 완료된 다음 날 새벽에 자동 업데이트됩니다. 주문 취소 또는 반품으로 승급 조건을 충족하지 못할 경우 승급되지 않습니다.",
        "users.membership.tier.expire.month": "{{month}}개월",
        "users.membership.tier.extend": "<b>{{tier}}</b> 등급 유지 조건 충족 여부",
        "users.membership.tier.extend.condition": "등급 유지 조건: ",
        "users.membership.tier.extend.single_purchase": "멤버십 유효 기간 {{month}}개월 내 {{dollar}} 이상의 주문이 없습니다",
        "users.membership.tier.extend.single_purchase.can_extend": "멤버십 기간 내 {{dollar}} 이상의 주문이 있습니다. 멤버십 만료 시 자동으로 갱신됩니다",
        "users.membership.tier.extend.top_level.single_purchase": "멤버십 기간 내 {{dollar}} 이상의 주문이 없습니다, ",
        "users.membership.tier.extend.top_level.single_purchase.can_extend": "멤버십 기간 내 {{dollar}} 이상의 주문이 있습니다. 달성을 축하합니다! 멤버십 만료 시 자동으로 갱신됩니다",
        "users.membership.tier.extend.top_level.within_interval": "등급 유지까지 {{dollar}} 남음",
        "users.membership.tier.extend.top_level.within_interval.can_extend": "달성을 축하합니다! 멤버십 만료 시 자동으로 갱신됩니다.",
        "users.membership.tier.extend.within_interval": "멤버십 유효 기간 {{month}}개월 내 누적 소비액 {{spending}}, 등급 유지까지 {{dollar}} 남음",
        "users.membership.tier.extend.within_interval.can_extend": "멤버십 유효 기간 {{month}}개월 내 누적 소비액이 {{dollar}}에 도달했습니다. 멤버십 만료 시 자동으로 갱신됩니다",
        "users.membership.tier.extension.date.description": "멤버십 만료 시, 주문 취소 또는 반품으로 등급 유지 조건을 충족하지 못할 경우 갱신되지 않습니다.",
        "users.membership.tier.shopping_discount": "쇼핑 시 {{discount}}% 할인",
        "users.membership.tier.upgrade.completed": "승급 조건 충족",
        "users.membership.tier.upgrade.condition": "현재 등급 승급 조건: ",
        "users.membership.tier.upgrade.condition.continue": "계속 쇼핑하기!",
        "users.membership.tier.upgrade.condition.dollar": "현재 {{ dollar }} 이상의 주문이 없습니다, ",
        "users.membership.tier.upgrade.gap_dollar": "승급까지 {{ dollar }} 부족",
        "users.membership.tier.upgrade.to_next_level.single": "승급 조건을 달성 여부",
        "users.membership.tier.upgrade.to_next_level.within": "{{month}}개월 내 누적 소비액",
        "users.membership.upgrade.next_tier": "{{tier_name}}(으)로 승급",
        "users.membership.upgrade.next_tier.discount": ", 쇼핑 시 {{discount}}% 할인",
        "users.phone.migrate.notification": "쇼핑몰 기능 업데이트 위해 2019/1/15 이후에는 고객님의 마지막 전화번호 1개만 보존됩니다. 여러 개의 번호가 등록돼 있는 경우, 마지막 번호가 정확한지 확인해 주세요",
        "users.save.email_verification.send": "인증 메일이 발송됐습니다",
        "users.save.email_verification.success": "변경 사항이 저장됐습니다. 메일은 인증 성공 후 업데이트됩니다",
        "users.save.success": "변경 사항이 저장됐습니다.",
        "users.signin.error.invalid.email": "아이디 또는 비밀번호가 올바르지 않습니다",
        "users.signin.error.invalid.mobile": "아이디 또는 비밀번호가 올바르지 않습니다",
        "users.signup.email": "메일로 가입하기",
        "users.signup.female": "여성",
        "users.signup.male": "남성",
        "users.signup.mobile_phone": "휴대폰 번호로 가입하기",
        "users.signup.other": "선택 안 함",
        "users.signup.unconfirmed": "다시 오신 것을 환영합니다! 계정 보안을 위해 계정 인증을 완료해야 로그인이 가능합니다. {{email}}로 인증 메일을 발송했습니다. 메일을 확인해 주세요. 감사합니다!",
        "users.signup.verification.hint.send": "인증 메일이 발송됐습니다. {{count}}초 후 재전송 가능합니다",
        "verification.email.trial_merchant.reach_limit.failure": "쇼핑몰이 시범 운영 중이라 인증 메일을 보낼 수 없습니다. 필요시 쇼핑몰에 문의해 주세요",
        "view_my_coupons": "",
        "whatsapp_messenger_checkbox.subscribe": "WhatsApp 구독하기",
        "wishlist.messages.remove_error": "찜하신 상품을 삭제하지 못했습니다.",
        "wishlist.signin_register": "로그인 / 회원 가입 바로가기",
        "zeek.pickup.area": "픽업 지역",
        "zeek.pickup.region": "픽업 구역",
        "zeek.station.address": "픽업 지점 주소",
        "zeek.station.name": "픽업 지점명",
        "zeek.station.provider": "픽업 서비스 제공업체"
      });
    $translateProvider.preferredLanguage("ko");
  },
]);
